<template>
  <div class="select-page parking-page">
    <div class="select-page__intro">
      <div class="texts">
        Подземный одноуровневый паркинг вмещает в себя 230 машиномест, в том
        числе увеличенные парковочные места для автомобилей представительского
        класса.
      </div>
      <div :class="['aparts-select-tool', 'aparts-select-tool--' + viewType]">
        <div class="parking-table">
          <div class="_row _row--empty">
            <div>Номер</div>
            <div>
              <div
                :class="[
                  '_sorting',
                  sortingField === 'area' ? '--active' : '',
                  sortingDirection == 'min-max' ? '--min-max' : '--max-min',
                ]"
                @click="changeSorting('area')"
              >
                <span class="arrow arrow--down arrow--no-line"
                  ><span></span></span
                >Площадь
              </div>
            </div>
            <div>
              <div
                :class="[
                  '_sorting',
                  sortingField === 'price' ? '--active' : '',
                  sortingDirection == 'min-max' ? '--min-max' : '--max-min',
                ]"
                @click="changeSorting('price')"
              >
                <span class="arrow arrow--down arrow--no-line"
                  ><span></span></span
                >Цена
              </div>
            </div>
            <div>Категория</div>
            <div>Комментарий</div>
          </div>
          <ParkingTableRow
            v-for="_slot in filteredSlots"
            :key="_slot.id"
            :item="_slot"
            @click="scrollToThePlan()"
          />
        </div>
        <div
          v-if="slots.length > filteredSlots.length"
          class="_show-more btn btn--light"
          @click="moreSlots"
        >
          Показать еще
        </div>
      </div>

      <div class="parking-scheme" id="parking-scheme">
        <div class="parking-scheme__title">Схема паркинга</div>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 862.74 540">
          <g id="background">
            <rect class="st7" y="0" width="862.74" height="540" />
          </g>
          <g id="Layer_11">
            <g>
              <rect
                class="st10"
                x="635.25"
                y="129.03"
                width="2.44"
                height="8.81"
                transform="translate(-9.55 207.95) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="658.7"
                y="135.13"
                width="2.44"
                height="8.81"
                transform="translate(-10.28 215.67) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="655.87"
                y="188.64"
                width="2.44"
                height="8.81"
                transform="translate(-27.33 217.52) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="648.63"
                y="243.25"
                width="2.44"
                height="8.81"
                transform="translate(-44.96 218.03) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="678.59"
                y="253.11"
                width="2.44"
                height="8.81"
                transform="translate(-46.54 228) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="650.31"
                y="289.43"
                width="2.44"
                height="8.81"
                transform="translate(-59.47 220.92) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="686.11"
                y="277.51"
                width="2.44"
                height="8.81"
                transform="translate(-53.86 231.62) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="702.55"
                y="327.02"
                width="2.44"
                height="8.81"
                transform="translate(-68.67 239.36) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="737.77"
                y="260.29"
                width="2.44"
                height="8.81"
                transform="translate(-45.78 247.07) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="754.18"
                y="309.66"
                width="2.44"
                height="8.81"
                transform="translate(-60.54 254.78) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="775.95"
                y="302.41"
                width="2.44"
                height="8.81"
                transform="translate(-57.13 261.29) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="790.93"
                y="340.71"
                width="2.44"
                height="20.76"
                transform="translate(-70.35 268.29) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="759.19"
                y="253.16"
                width="2.44"
                height="8.81"
                transform="translate(-42.43 253.47) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="709.68"
                y="117.79"
                width="2.44"
                height="8.81"
                transform="translate(-2.19 230.89) rotate(-18.42)"
              />
              <rect
                class="st10"
                x="37.18"
                y="114.9"
                width="7.71"
                height="2.29"
              />
              <rect
                class="st10"
                x="37.18"
                y="138.03"
                width="7.71"
                height="2.29"
              />
              <rect
                class="st10"
                x="37.18"
                y="192.04"
                width="7.71"
                height="2.29"
              />
              <rect
                class="st10"
                x="37.18"
                y="245.99"
                width="7.71"
                height="2.29"
              />
              <rect
                class="st10"
                x="37.18"
                y="300.74"
                width="7.71"
                height="2.29"
              />
              <rect
                class="st10"
                x="37.18"
                y="354.71"
                width="7.71"
                height="2.29"
              />
              <rect
                class="st10"
                x="37.18"
                y="397.13"
                width="7.71"
                height="2.29"
              />
              <rect
                class="st10"
                x="37.18"
                y="451.87"
                width="7.71"
                height="2.29"
              />
              <rect
                class="st10"
                x="37.18"
                y="490.42"
                width="7.71"
                height="2.29"
              />
              <g>
                <rect
                  class="st10"
                  x="86.56"
                  y="138.03"
                  width="6.9"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="86.56"
                  y="192.04"
                  width="6.9"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="86.56"
                  y="245.99"
                  width="6.9"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="86.56"
                  y="300.74"
                  width="6.9"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="86.56"
                  y="354.71"
                  width="6.9"
                  height="3.03"
                />
                <rect
                  class="st10"
                  x="86.56"
                  y="397.13"
                  width="6.9"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="86.56"
                  y="451.87"
                  width="6.9"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="86.56"
                  y="490.42"
                  width="6.9"
                  height="2.29"
                />
              </g>
              <g>
                <rect
                  class="st10"
                  x="259.33"
                  y="138.03"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="259.33"
                  y="192.04"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="259.33"
                  y="245.99"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="259.33"
                  y="300.74"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="259.33"
                  y="354.71"
                  width="8.43"
                  height="3.03"
                />
                <rect
                  class="st10"
                  x="259.33"
                  y="397.13"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="259.33"
                  y="435.66"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="259.33"
                  y="473.48"
                  width="8.43"
                  height="2.29"
                />
              </g>
              <g>
                <rect
                  class="st10"
                  x="314.87"
                  y="138.03"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="314.87"
                  y="192.04"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="314.87"
                  y="245.99"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="314.87"
                  y="300.74"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="314.87"
                  y="354.71"
                  width="8.43"
                  height="3.03"
                />
                <rect
                  class="st10"
                  x="314.87"
                  y="397.13"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="314.87"
                  y="435.66"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="314.87"
                  y="473.48"
                  width="8.43"
                  height="2.29"
                />
              </g>
              <g>
                <rect
                  class="st10"
                  x="368.84"
                  y="138.03"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="368.84"
                  y="192.04"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="368.84"
                  y="245.99"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="368.84"
                  y="300.74"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="368.84"
                  y="354.71"
                  width="8.43"
                  height="3.03"
                />
                <rect
                  class="st10"
                  x="368.84"
                  y="397.13"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="368.84"
                  y="435.66"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="368.84"
                  y="473.48"
                  width="8.43"
                  height="2.29"
                />
              </g>
              <g>
                <rect
                  class="st10"
                  x="423.63"
                  y="138.03"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="423.63"
                  y="192.04"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="423.63"
                  y="245.99"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="423.63"
                  y="300.74"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="423.63"
                  y="354.71"
                  width="8.43"
                  height="3.03"
                />
                <rect
                  class="st10"
                  x="422.07"
                  y="397.13"
                  width="9.22"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="449.77"
                  y="397.13"
                  width="8.53"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="422.07"
                  y="435.66"
                  width="9.22"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="422.07"
                  y="473.48"
                  width="9.22"
                  height="2.29"
                />
              </g>
              <g>
                <rect
                  class="st10"
                  x="540.05"
                  y="138.03"
                  width="9.25"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="540.05"
                  y="192.04"
                  width="9.25"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="540.05"
                  y="245.99"
                  width="9.25"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="540.05"
                  y="300.74"
                  width="9.25"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="540.05"
                  y="354.71"
                  width="9.25"
                  height="3.03"
                />
                <rect
                  class="st10"
                  x="540.05"
                  y="397.13"
                  width="9.22"
                  height="3.07"
                />
              </g>
              <g>
                <rect
                  class="st10"
                  x="595.58"
                  y="138.03"
                  width="8.48"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="595.58"
                  y="192.04"
                  width="8.48"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="595.58"
                  y="245.99"
                  width="8.48"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="595.58"
                  y="300.74"
                  width="8.48"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="595.58"
                  y="354.71"
                  width="8.48"
                  height="3.03"
                />
                <rect
                  class="st10"
                  x="590.94"
                  y="397.13"
                  width="7.71"
                  height="3.07"
                />
              </g>
              <g>
                <rect
                  class="st10"
                  x="484.53"
                  y="138.03"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="484.53"
                  y="192.04"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="484.53"
                  y="245.99"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="484.53"
                  y="300.74"
                  width="8.43"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="457.56"
                  y="354.71"
                  width="35.4"
                  height="3.03"
                />
              </g>
              <rect
                class="st10"
                x="234.61"
                y="397.13"
                width="9.25"
                height="2.29"
              />
              <rect
                class="st10"
                x="234.61"
                y="435.66"
                width="9.25"
                height="2.29"
              />
              <rect
                class="st10"
                x="234.61"
                y="473.48"
                width="9.25"
                height="2.29"
              />
              <g>
                <rect
                  class="st10"
                  x="203.02"
                  y="138.03"
                  width="8.45"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="203.02"
                  y="192.04"
                  width="8.45"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="203.02"
                  y="245.99"
                  width="8.45"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="203.02"
                  y="300.74"
                  width="8.45"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="196.86"
                  y="354.71"
                  width="38.53"
                  height="3.03"
                />
                <rect
                  class="st10"
                  x="232.98"
                  y="99.4"
                  width="1.9"
                  height="258.33"
                />
                <rect
                  class="st10"
                  x="458.73"
                  y="137.72"
                  width="1.35"
                  height="220.02"
                />
                <rect
                  class="st10"
                  x="193.39"
                  y="397.13"
                  width="6.5"
                  height="2.29"
                />
              </g>
              <g>
                <rect
                  class="st10"
                  x="149.06"
                  y="245.99"
                  width="6.9"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="149.06"
                  y="300.74"
                  width="6.9"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="149.06"
                  y="354.71"
                  width="6.9"
                  height="3.03"
                />
              </g>
              <g>
                <rect
                  class="st10"
                  x="120.53"
                  y="192.04"
                  width="3.06"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="118.94"
                  y="245.99"
                  width="4.65"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="118.94"
                  y="300.74"
                  width="4.65"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="118.94"
                  y="354.71"
                  width="4.65"
                  height="3.03"
                />
                <rect
                  class="st10"
                  x="113.58"
                  y="397.13"
                  width="7.71"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="113.58"
                  y="451.87"
                  width="7.71"
                  height="2.29"
                />
                <rect
                  class="st10"
                  x="113.58"
                  y="490.42"
                  width="7.71"
                  height="2.29"
                />
              </g>
            </g>
            <g>
              <rect
                class="st9"
                x="617.92"
                y="121.7"
                width="18.83"
                height="35.81"
                transform="translate(-11.97 205.38) rotate(-18.42)"
              />
              <rect
                class="st9"
                x="638.3"
                y="115.11"
                width="17.69"
                height="35.81"
                transform="translate(-8.87 211.3) rotate(-18.42)"
              />
              <g>
                <rect
                  class="st9"
                  x="657.34"
                  y="108.86"
                  width="17.15"
                  height="35.81"
                  transform="translate(-5.94 216.91) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="673.6"
                  y="103.44"
                  width="17.15"
                  height="35.81"
                  transform="translate(-3.39 221.77) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="689.87"
                  y="98.01"
                  width="17.15"
                  height="35.81"
                  transform="translate(-.84 226.63) rotate(-18.42)"
                />
              </g>
              <g>
                <rect
                  class="st9"
                  x="707.91"
                  y="88.21"
                  width="19.12"
                  height="39.13"
                  transform="translate(2.7 232.23) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="726.04"
                  y="82.19"
                  width="19.12"
                  height="39.13"
                  transform="translate(5.53 237.65) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="744.17"
                  y="76.13"
                  width="19.12"
                  height="39.13"
                  transform="translate(8.38 243.07) rotate(-18.42)"
                />
              </g>
              <g>
                <rect
                  class="st9"
                  x="735.27"
                  y="159.01"
                  width="17.49"
                  height="35.79"
                  transform="translate(-17.78 244.16) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="751.87"
                  y="153.5"
                  width="17.49"
                  height="35.79"
                  transform="translate(-15.19 249.12) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="768.44"
                  y="147.95"
                  width="17.49"
                  height="35.79"
                  transform="translate(-12.59 254.07) rotate(-18.42)"
                />
              </g>
              <g>
                <rect
                  class="st9"
                  x="746.81"
                  y="192.95"
                  width="17.49"
                  height="37.11"
                  transform="translate(-28.12 249.58) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="763.39"
                  y="187.4"
                  width="17.49"
                  height="37.11"
                  transform="translate(-25.52 254.53) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="779.99"
                  y="181.89"
                  width="17.49"
                  height="37.11"
                  transform="translate(-22.93 259.49) rotate(-18.42)"
                />
              </g>
              <g>
                <rect
                  class="st9"
                  x="758.05"
                  y="228.23"
                  width="17.49"
                  height="34.03"
                  transform="translate(-38.21 254.86) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="774.63"
                  y="222.71"
                  width="17.49"
                  height="34.03"
                  transform="translate(-35.61 259.81) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="791.22"
                  y="217.18"
                  width="17.49"
                  height="34.03"
                  transform="translate(-33.02 264.77) rotate(-18.42)"
                />
              </g>
              <g>
                <rect
                  class="st9"
                  x="781.36"
                  y="295.3"
                  width="17.57"
                  height="37.13"
                  transform="translate(-58.69 265.75) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="798.02"
                  y="289.75"
                  width="17.57"
                  height="37.13"
                  transform="translate(-56.09 270.73) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="814.68"
                  y="284.2"
                  width="17.57"
                  height="37.13"
                  transform="translate(-53.48 275.71) rotate(-18.42)"
                />
              </g>
              <g>
                <rect
                  class="st9"
                  x="792.63"
                  y="330.61"
                  width="17.57"
                  height="34.2"
                  transform="translate(-68.81 271.05) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="792.63"
                  y="330.61"
                  width="17.57"
                  height="34.2"
                  transform="translate(-68.81 271.05) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="809.29"
                  y="325.06"
                  width="17.57"
                  height="34.2"
                  transform="translate(-66.2 276.03) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="825.97"
                  y="319.51"
                  width="17.57"
                  height="34.2"
                  transform="translate(-63.59 281.01) rotate(-18.42)"
                />
              </g>
              <g>
                <rect
                  class="st9"
                  x="685.11"
                  y="250.3"
                  width="17.18"
                  height="36.36"
                  transform="translate(-49.29 232.95) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="701.4"
                  y="244.88"
                  width="17.18"
                  height="36.36"
                  transform="translate(-46.75 237.82) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="648.91"
                  y="262.51"
                  width="17.72"
                  height="36.21"
                  transform="translate(-54.97 222.22) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="665.71"
                  y="256.91"
                  width="17.72"
                  height="36.21"
                  transform="translate(-52.34 227.24) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="649.66"
                  y="223.3"
                  width="22.44"
                  height="36.21"
                  transform="translate(-42.42 221.19) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="648.62"
                  y="190.44"
                  width="7.37"
                  height="22.67"
                  transform="translate(-30.34 216.45) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="668.9"
                  y="175.61"
                  width="40.86"
                  height="22.46"
                  transform="translate(-23.72 227.39) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="717.7"
                  y="239.44"
                  width="17.18"
                  height="36.36"
                  transform="translate(-44.19 242.69) rotate(-18.42)"
                />
                <rect
                  class="st9"
                  x="736.25"
                  y="232.77"
                  width="20.1"
                  height="36.36"
                  transform="translate(-41.06 248.67) rotate(-18.42)"
                />
              </g>
              <rect
                class="st4"
                x="8.25"
                y="117.19"
                width="37.04"
                height="20.84"
              />
              <g>
                <rect
                  class="st4"
                  x="8.25"
                  y="140.32"
                  width="37.04"
                  height="17.24"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="157.56"
                  width="37.04"
                  height="17.24"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="174.8"
                  width="37.04"
                  height="17.24"
                />
              </g>
              <g>
                <rect
                  class="st4"
                  x="8.25"
                  y="194.33"
                  width="37.04"
                  height="17.22"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="211.55"
                  width="37.04"
                  height="17.22"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="228.77"
                  width="37.04"
                  height="17.22"
                />
              </g>
              <g>
                <rect
                  class="st4"
                  x="8.25"
                  y="248.28"
                  width="37.04"
                  height="17.49"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="265.76"
                  width="37.04"
                  height="17.49"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="283.25"
                  width="37.04"
                  height="17.49"
                />
              </g>
              <g>
                <rect
                  class="st4"
                  x="8.25"
                  y="337.48"
                  width="37.04"
                  height="17.23"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="320.26"
                  width="37.04"
                  height="17.23"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="303.03"
                  width="37.04"
                  height="17.23"
                />
              </g>
              <g>
                <rect
                  class="st4"
                  x="8.25"
                  y="434.39"
                  width="37.04"
                  height="17.49"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="416.9"
                  width="37.04"
                  height="17.49"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="399.42"
                  width="37.04"
                  height="17.49"
                />
              </g>
              <g>
                <rect
                  class="st4"
                  x="8.25"
                  y="357"
                  width="37.04"
                  height="20.06"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="377.06"
                  width="37.04"
                  height="20.06"
                />
              </g>
              <g>
                <rect
                  class="st4"
                  x="8.25"
                  y="454.16"
                  width="37.04"
                  height="18.13"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="472.29"
                  width="37.04"
                  height="18.13"
                />
              </g>
              <g>
                <rect
                  class="st4"
                  x="8.25"
                  y="492.71"
                  width="37.04"
                  height="19.17"
                />
                <rect
                  class="st4"
                  x="8.25"
                  y="511.89"
                  width="37.04"
                  height="19.17"
                />
              </g>
              <g>
                <g>
                  <rect
                    class="st4"
                    x="84.61"
                    y="140.32"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="84.61"
                    y="157.56"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="84.61"
                    y="174.8"
                    width="36.22"
                    height="17.24"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="84.61"
                    y="194.33"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="84.61"
                    y="211.55"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="84.61"
                    y="228.77"
                    width="36.22"
                    height="17.22"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="84.61"
                    y="248.28"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="84.61"
                    y="265.76"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="84.61"
                    y="283.25"
                    width="36.22"
                    height="17.49"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="84.61"
                    y="337.48"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="84.61"
                    y="320.26"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="84.61"
                    y="303.03"
                    width="36.22"
                    height="17.23"
                  />
                </g>
              </g>
              <g>
                <g>
                  <rect
                    class="st4"
                    x="196.76"
                    y="140.32"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="196.76"
                    y="157.56"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="196.76"
                    y="101.23"
                    width="36.22"
                    height="18.4"
                  />
                  <rect
                    class="st4"
                    x="196.76"
                    y="119.63"
                    width="36.22"
                    height="18.4"
                  />
                  <rect
                    class="st4"
                    x="196.76"
                    y="174.8"
                    width="36.22"
                    height="17.24"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="196.76"
                    y="194.33"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="196.76"
                    y="211.55"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="196.76"
                    y="228.77"
                    width="36.22"
                    height="17.22"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="196.76"
                    y="248.28"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="196.76"
                    y="265.76"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="196.76"
                    y="283.25"
                    width="36.22"
                    height="17.49"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="196.76"
                    y="337.48"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="196.76"
                    y="320.26"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="197.88"
                    y="455.72"
                    width="36.74"
                    height="17.76"
                  />
                  <rect
                    class="st4"
                    x="197.88"
                    y="437.95"
                    width="36.74"
                    height="17.76"
                  />
                  <rect
                    class="st4"
                    x="197.88"
                    y="399.42"
                    width="17.81"
                    height="35.89"
                  />
                  <rect
                    class="st4"
                    x="215.69"
                    y="399.42"
                    width="17.81"
                    height="35.89"
                  />
                  <rect
                    class="st4"
                    x="196.76"
                    y="303.03"
                    width="36.22"
                    height="17.23"
                  />
                </g>
              </g>
              <g>
                <g>
                  <rect
                    class="st4"
                    x="234.88"
                    y="140.32"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="234.88"
                    y="157.56"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="234.88"
                    y="101.23"
                    width="36.22"
                    height="18.4"
                  />
                  <rect
                    class="st4"
                    x="234.88"
                    y="119.63"
                    width="36.22"
                    height="18.4"
                  />
                  <rect
                    class="st4"
                    x="234.88"
                    y="174.8"
                    width="36.22"
                    height="17.24"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="234.88"
                    y="194.33"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="234.88"
                    y="211.55"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="234.88"
                    y="228.77"
                    width="36.22"
                    height="17.22"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="234.88"
                    y="248.28"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="234.88"
                    y="265.76"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="234.88"
                    y="283.25"
                    width="36.22"
                    height="17.49"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="234.88"
                    y="337.48"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="234.88"
                    y="320.26"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="234.88"
                    y="303.03"
                    width="36.22"
                    height="17.23"
                  />
                </g>
                <rect
                  class="st4"
                  x="234.61"
                  y="455.72"
                  width="36.74"
                  height="17.76"
                />
                <rect
                  class="st4"
                  x="234.61"
                  y="437.95"
                  width="36.74"
                  height="17.76"
                />
                <rect
                  class="st4"
                  x="234.61"
                  y="493.67"
                  width="36.74"
                  height="17.9"
                />
                <rect
                  class="st4"
                  x="234.61"
                  y="511.58"
                  width="36.74"
                  height="17.9"
                />
                <rect
                  class="st4"
                  x="234.61"
                  y="475.77"
                  width="36.74"
                  height="17.9"
                />
                <rect
                  class="st4"
                  x="234.61"
                  y="417.36"
                  width="36.74"
                  height="17.94"
                />
                <rect
                  class="st4"
                  x="234.61"
                  y="399.42"
                  width="36.74"
                  height="17.94"
                />
              </g>
              <g>
                <g>
                  <rect
                    class="st4"
                    x="308.83"
                    y="140.32"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="308.83"
                    y="157.56"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="308.83"
                    y="101.23"
                    width="36.22"
                    height="18.4"
                  />
                  <rect
                    class="st4"
                    x="308.83"
                    y="119.63"
                    width="36.22"
                    height="18.4"
                  />
                  <rect
                    class="st4"
                    x="308.83"
                    y="174.8"
                    width="36.22"
                    height="17.24"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="308.83"
                    y="194.33"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="308.83"
                    y="211.55"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="308.83"
                    y="228.77"
                    width="36.22"
                    height="17.22"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="308.83"
                    y="248.28"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="308.83"
                    y="265.76"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="308.83"
                    y="283.25"
                    width="36.22"
                    height="17.49"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="308.83"
                    y="337.48"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="308.83"
                    y="320.26"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="308.83"
                    y="303.03"
                    width="36.22"
                    height="17.23"
                  />
                </g>
                <rect
                  class="st4"
                  x="308.56"
                  y="455.72"
                  width="36.74"
                  height="17.76"
                />
                <rect
                  class="st4"
                  x="308.56"
                  y="437.95"
                  width="36.74"
                  height="17.76"
                />
                <rect
                  class="st4"
                  x="308.56"
                  y="493.67"
                  width="36.74"
                  height="17.9"
                />
                <rect
                  class="st4"
                  x="308.56"
                  y="511.58"
                  width="36.74"
                  height="17.9"
                />
                <rect
                  class="st4"
                  x="308.56"
                  y="475.77"
                  width="36.74"
                  height="17.9"
                />
                <rect
                  class="st4"
                  x="308.56"
                  y="417.36"
                  width="36.74"
                  height="17.94"
                />
                <rect
                  class="st4"
                  x="308.56"
                  y="399.42"
                  width="36.74"
                  height="17.94"
                />
              </g>
              <rect
                class="st4"
                x="294.27"
                y="61.34"
                width="21.72"
                height="34.68"
              />
              <rect
                class="st4"
                x="272.56"
                y="61.35"
                width="21.72"
                height="34.68"
              />
              <g>
                <g>
                  <rect
                    class="st4"
                    x="347.06"
                    y="140.32"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="347.06"
                    y="157.56"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="347.06"
                    y="101.23"
                    width="36.22"
                    height="18.4"
                  />
                  <rect
                    class="st4"
                    x="347.06"
                    y="119.63"
                    width="36.22"
                    height="18.4"
                  />
                  <rect
                    class="st4"
                    x="347.06"
                    y="174.8"
                    width="36.22"
                    height="17.24"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="347.06"
                    y="194.33"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="347.06"
                    y="211.55"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="347.06"
                    y="228.77"
                    width="36.22"
                    height="17.22"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="347.06"
                    y="248.28"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="347.06"
                    y="265.76"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="347.06"
                    y="283.25"
                    width="36.22"
                    height="17.49"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="347.06"
                    y="337.48"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="347.06"
                    y="320.26"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="347.06"
                    y="303.03"
                    width="36.22"
                    height="17.23"
                  />
                </g>
                <rect
                  class="st4"
                  x="346.79"
                  y="455.72"
                  width="36.74"
                  height="17.76"
                />
                <rect
                  class="st4"
                  x="346.79"
                  y="437.95"
                  width="36.74"
                  height="17.76"
                />
                <rect
                  class="st4"
                  x="346.79"
                  y="493.67"
                  width="36.74"
                  height="17.9"
                />
                <rect
                  class="st4"
                  x="346.79"
                  y="511.58"
                  width="36.74"
                  height="17.9"
                />
                <rect
                  class="st4"
                  x="346.79"
                  y="475.77"
                  width="36.74"
                  height="17.9"
                />
                <rect
                  class="st4"
                  x="346.79"
                  y="417.36"
                  width="36.74"
                  height="17.94"
                />
                <rect
                  class="st4"
                  x="346.79"
                  y="399.42"
                  width="36.74"
                  height="17.94"
                />
              </g>
              <g>
                <g>
                  <rect
                    class="st4"
                    x="422.52"
                    y="140.32"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="422.52"
                    y="157.56"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="422.52"
                    y="102.11"
                    width="20.72"
                    height="35.92"
                  />
                  <rect
                    class="st4"
                    x="422.52"
                    y="174.8"
                    width="36.22"
                    height="17.24"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="422.52"
                    y="194.33"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="422.52"
                    y="211.55"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="422.52"
                    y="228.77"
                    width="36.22"
                    height="17.22"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="422.52"
                    y="248.28"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="422.52"
                    y="265.76"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="422.52"
                    y="283.25"
                    width="36.22"
                    height="17.49"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="422.52"
                    y="337.48"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="422.52"
                    y="320.26"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="422.52"
                    y="303.03"
                    width="36.22"
                    height="17.23"
                  />
                </g>
                <rect
                  class="st4"
                  x="422.25"
                  y="455.72"
                  width="36.74"
                  height="17.76"
                />
                <rect
                  class="st4"
                  x="422.25"
                  y="437.95"
                  width="36.74"
                  height="17.76"
                />
                <rect
                  class="st4"
                  x="422.25"
                  y="493.67"
                  width="36.74"
                  height="17.9"
                />
                <rect
                  class="st4"
                  x="422.25"
                  y="511.58"
                  width="36.74"
                  height="17.9"
                />
                <rect
                  class="st4"
                  x="422.25"
                  y="475.77"
                  width="36.74"
                  height="17.9"
                />
                <rect
                  class="st4"
                  x="422.25"
                  y="417.36"
                  width="36.74"
                  height="17.94"
                />
                <rect
                  class="st4"
                  x="422.25"
                  y="399.42"
                  width="36.74"
                  height="17.94"
                />
              </g>
              <g>
                <g>
                  <rect
                    class="st4"
                    x="460.08"
                    y="140.32"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="460.08"
                    y="157.56"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="460.08"
                    y="174.8"
                    width="36.22"
                    height="17.24"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="460.08"
                    y="194.33"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="460.08"
                    y="211.55"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="460.08"
                    y="228.77"
                    width="36.22"
                    height="17.22"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="460.08"
                    y="248.28"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="460.08"
                    y="265.76"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="460.08"
                    y="283.25"
                    width="36.22"
                    height="17.49"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="460.08"
                    y="337.48"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="460.08"
                    y="320.26"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="460.08"
                    y="303.03"
                    width="36.22"
                    height="17.23"
                  />
                </g>
              </g>
              <g>
                <g>
                  <rect
                    class="st4"
                    x="535.03"
                    y="140.32"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="535.03"
                    y="157.56"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="535.03"
                    y="101.87"
                    width="36.22"
                    height="18.08"
                  />
                  <rect
                    class="st4"
                    x="535.03"
                    y="119.95"
                    width="36.22"
                    height="18.08"
                  />
                  <rect
                    class="st4"
                    x="535.03"
                    y="174.8"
                    width="36.22"
                    height="17.24"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="535.03"
                    y="194.33"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="535.03"
                    y="211.55"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="535.03"
                    y="228.77"
                    width="36.22"
                    height="17.22"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="535.03"
                    y="248.28"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="535.03"
                    y="265.76"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="535.03"
                    y="283.25"
                    width="36.22"
                    height="17.49"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="535.03"
                    y="337.48"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="491.87"
                    y="396.12"
                    width="47.66"
                    height="19.1"
                  />
                  <rect
                    class="st4"
                    x="550.3"
                    y="396.12"
                    width="39.32"
                    height="19.1"
                  />
                  <rect
                    class="st4"
                    x="535.03"
                    y="320.26"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="535.03"
                    y="303.03"
                    width="36.22"
                    height="17.23"
                  />
                </g>
              </g>
              <g>
                <g>
                  <rect
                    class="st4"
                    x="572.77"
                    y="140.32"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="610.59"
                    y="145.98"
                    width="7.59"
                    height="22.14"
                  />
                  <rect
                    class="st4"
                    x="572.77"
                    y="157.56"
                    width="36.22"
                    height="17.24"
                  />
                  <rect
                    class="st4"
                    x="572.77"
                    y="101.87"
                    width="36.22"
                    height="18.08"
                  />
                  <rect
                    class="st4"
                    x="572.77"
                    y="119.95"
                    width="36.22"
                    height="18.08"
                  />
                  <rect
                    class="st4"
                    x="572.77"
                    y="174.8"
                    width="36.22"
                    height="17.24"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="572.77"
                    y="194.33"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="572.77"
                    y="211.55"
                    width="36.22"
                    height="17.22"
                  />
                  <rect
                    class="st4"
                    x="572.77"
                    y="228.77"
                    width="36.22"
                    height="17.22"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="572.77"
                    y="248.28"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="572.77"
                    y="265.76"
                    width="36.22"
                    height="17.49"
                  />
                  <rect
                    class="st4"
                    x="572.77"
                    y="283.25"
                    width="36.22"
                    height="17.49"
                  />
                </g>
                <g>
                  <rect
                    class="st4"
                    x="572.77"
                    y="337.48"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="572.77"
                    y="320.26"
                    width="36.22"
                    height="17.23"
                  />
                  <rect
                    class="st4"
                    x="572.77"
                    y="303.03"
                    width="36.22"
                    height="17.23"
                  />
                </g>
              </g>
              <g>
                <rect
                  class="st4"
                  x="84.61"
                  y="434.39"
                  width="36.22"
                  height="17.49"
                />
                <rect
                  class="st4"
                  x="84.61"
                  y="416.9"
                  width="36.22"
                  height="17.49"
                />
                <rect
                  class="st4"
                  x="84.61"
                  y="399.42"
                  width="36.22"
                  height="17.49"
                />
                <rect
                  class="st4"
                  x="120.82"
                  y="397.38"
                  width="18.64"
                  height="35.3"
                />
              </g>
              <g>
                <rect
                  class="st4"
                  x="84.61"
                  y="454.16"
                  width="36.22"
                  height="18.13"
                />
                <rect
                  class="st4"
                  x="84.61"
                  y="472.29"
                  width="36.22"
                  height="18.13"
                />
              </g>
              <g>
                <rect
                  class="st4"
                  x="84.61"
                  y="492.71"
                  width="36.22"
                  height="19.17"
                />
                <rect
                  class="st4"
                  x="84.61"
                  y="511.89"
                  width="36.22"
                  height="19.17"
                />
              </g>
              <g>
                <rect
                  class="st4"
                  x="122.44"
                  y="194.33"
                  width="36.22"
                  height="17.22"
                />
                <rect
                  class="st4"
                  x="122.44"
                  y="211.55"
                  width="36.22"
                  height="17.22"
                />
                <rect
                  class="st4"
                  x="122.44"
                  y="228.77"
                  width="36.22"
                  height="17.22"
                />
              </g>
              <g>
                <rect
                  class="st4"
                  x="122.44"
                  y="248.28"
                  width="36.22"
                  height="17.49"
                />
                <rect
                  class="st4"
                  x="122.44"
                  y="265.76"
                  width="36.22"
                  height="17.49"
                />
                <rect
                  class="st4"
                  x="122.44"
                  y="283.25"
                  width="36.22"
                  height="17.49"
                />
              </g>
              <g>
                <rect
                  class="st4"
                  x="122.44"
                  y="337.48"
                  width="36.22"
                  height="17.23"
                />
                <rect
                  class="st4"
                  x="122.44"
                  y="320.26"
                  width="36.22"
                  height="17.23"
                />
                <rect
                  class="st4"
                  x="122.44"
                  y="303.03"
                  width="36.22"
                  height="17.23"
                />
              </g>
              <rect
                class="st9"
                x="759.59"
                y="302.55"
                width="20.7"
                height="37.13"
                transform="translate(-62.02 259.74) rotate(-18.42)"
              />
              <rect
                class="st9"
                x="714.83"
                y="313.79"
                width="40"
                height="19.57"
                transform="translate(-64.59 248.77) rotate(-18.42)"
              />
              <rect
                class="st9"
                x="678.22"
                y="328.75"
                width="21.41"
                height="7.71"
                transform="translate(-69.8 234.73) rotate(-18.42)"
              />
              <rect
                class="st9"
                x="770.86"
                y="337.87"
                width="20.7"
                height="34.2"
                transform="translate(-72.14 265.03) rotate(-18.42)"
              />
            </g>
            <g>
              <polyline class="st5" points="8.25 114.9 53.8 114.9 53.8 75.92" />
              <rect
                class="st5"
                x="130.09"
                y="502.92"
                width="15.49"
                height="28.14"
              />
              <rect
                class="st5"
                x="221.17"
                y="477.56"
                width="12.07"
                height="53.5"
              />
              <rect
                class="st5"
                x="567.38"
                y="477.55"
                width="16.93"
                height="53.5"
              />
              <rect
                class="st5"
                x="465.68"
                y="460.04"
                width="21.02"
                height="17.52"
              />
              <rect
                class="st5"
                x="486.7"
                y="460.03"
                width="38.76"
                height="17.52"
              />
              <rect
                class="st5"
                x="525.45"
                y="460.04"
                width="43.36"
                height="17.52"
              />
              <rect
                class="st5"
                x="535.93"
                y="444.7"
                width="32.88"
                height="15.33"
              />
              <rect
                class="st5"
                x="568.82"
                y="444.7"
                width="16.47"
                height="15.33"
              />
              <rect
                class="st5"
                x="535.94"
                y="421.56"
                width="49.35"
                height="23.15"
              />
              <rect
                class="st5"
                x="535.94"
                y="417.37"
                width="11.2"
                height="4.19"
              />
              <rect
                class="st5"
                x="512.65"
                y="417.37"
                width="23.29"
                height="30.87"
              />
              <rect
                class="st5"
                x="489.84"
                y="417.37"
                width="22.81"
                height="30.87"
              />
              <rect
                class="st5"
                x="471.99"
                y="432.06"
                width="17.85"
                height="16.18"
              />
              <rect
                class="st5"
                x="476.2"
                y="417.37"
                width="13.64"
                height="14.69"
              />
              <polygon
                class="st5"
                points="478.53 397.84 478.53 400.12 465.69 400.12 465.69 417.37 478.53 417.37 489.84 417.37 489.84 400.12 489.84 397.84 478.53 397.84"
              />
              <polygon
                class="st5"
                points="465.69 477.56 465.69 513.46 483.29 513.46 483.29 531.06 567.39 531.06 567.39 513.46 567.39 477.56 465.69 477.56"
              />
              <rect
                class="st5"
                x="465.69"
                y="513.46"
                width="17.6"
                height="17.6"
              />
              <polyline
                class="st5"
                points="221.17 477.56 193.39 477.56 193.39 469.91"
              />
              <rect
                class="st5"
                x="130.09"
                y="486.55"
                width="39.19"
                height="16.37"
              />
              <rect class="st5" x="188.39" y="469.91" width="5" height="5" />
              <rect
                class="st5"
                x="130.09"
                y="448.94"
                width="16.1"
                height="20.97"
              />
              <polygon
                class="st5"
                points="159.91 476.38 159.91 469.91 130.09 469.91 130.09 486.55 159.91 486.55 169.28 486.55 169.28 476.38 159.91 476.38"
              />
              <rect
                class="st5"
                x="146.19"
                y="448.94"
                width="47.2"
                height="20.97"
              />
              <rect
                class="st5"
                x="146.19"
                y="416.78"
                width="47.2"
                height="32.16"
              />
              <rect
                class="st5"
                x="177.54"
                y="431.45"
                width="15.86"
                height="17.48"
              />
              <rect
                class="st5"
                x="162.55"
                y="435.9"
                width="14.98"
                height="13.04"
              />
              <rect
                class="st5"
                x="146.19"
                y="398.28"
                width="47.2"
                height="18.5"
              />
              <line
                class="st5"
                x1="162.55"
                y1="430.52"
                x2="162.55"
                y2="435.9"
              />
              <line
                class="st5"
                x1="585.29"
                y1="421.56"
                x2="611.67"
                y2="421.56"
              />
              <polyline
                class="st5"
                points="753.64 400.02 753.64 343.05 648.35 343.05 648.35 346.77"
              />
              <line
                class="st5"
                x1="648.35"
                y1="371.54"
                x2="744.46"
                y2="371.54"
              />
              <line
                class="st5"
                x1="753.64"
                y1="343.05"
                x2="735.21"
                y2="400.02"
              />
              <line
                class="st5"
                x1="753.64"
                y1="380.92"
                x2="850.67"
                y2="380.92"
              />
              <line
                class="st5"
                x1="792.93"
                y1="380.92"
                x2="792.93"
                y2="400.02"
              />
              <line
                class="st5"
                x1="806.29"
                y1="380.92"
                x2="806.29"
                y2="400.02"
              />
              <line
                class="st5"
                x1="819.21"
                y1="380.92"
                x2="819.21"
                y2="400.02"
              />
              <line
                class="st5"
                x1="648.35"
                y1="396.31"
                x2="648.35"
                y2="400.02"
              />
              <polygon
                class="st5"
                points="125.66 86.57 90.96 86.57 90.96 71.31 125.66 67 125.66 86.57"
              />
              <rect
                class="st5"
                x="90.96"
                y="86.57"
                width="17.17"
                height="18.56"
              />
              <rect
                class="st5"
                x="90.96"
                y="105.12"
                width="17.17"
                height="21.28"
              />
              <rect
                class="st5"
                x="108.13"
                y="109.75"
                width="13.49"
                height="16.65"
              />
              <rect
                class="st5"
                x="121.62"
                y="109.76"
                width="4.03"
                height="6.01"
              />
              <rect
                class="st5"
                x="108.13"
                y="86.57"
                width="17.52"
                height="23.19"
              />
              <rect
                class="st5"
                x="122.44"
                y="149.17"
                width="30.61"
                height="23.13"
              />
              <g>
                <rect
                  class="st5"
                  x="137.44"
                  y="172.3"
                  width="15.61"
                  height="17.26"
                />
                <rect
                  class="st5"
                  x="122.44"
                  y="172.3"
                  width="15"
                  height="13.19"
                />
              </g>
              <polygon
                class="st5"
                points="164.49 62.19 125.66 67 125.66 99.4 164.49 99.4 164.49 62.19"
              />
              <polygon
                class="st5"
                points="164.49 62.19 182.96 59.91 182.96 99.4 164.49 99.4 164.49 62.19"
              />
              <polygon
                class="st5"
                points="233.92 53.55 182.96 59.91 182.96 99.4 233.92 99.4 233.92 53.55"
              />
              <polygon
                class="st5"
                points="233.92 53.55 265.93 49.56 265.93 96.03 233.92 96.03 233.92 53.55"
              />
              <polygon
                class="st5"
                points="272.45 48.78 265.93 49.56 265.93 93.61 272.45 93.61 272.45 48.78"
              />
              <polygon
                class="st5"
                points="315.99 43.37 326.12 42.12 326.12 68.18 315.99 68.18 315.99 43.37"
              />
              <polygon
                class="st5"
                points="125.66 77.71 125.66 115.76 121.62 115.76 121.62 126.41 125.66 126.41 149.35 126.41 149.35 77.71 125.66 77.71"
              />
              <polyline
                class="st5"
                points="354.12 38.64 356.07 54.31 381.05 50.84 386.27 96.03 315.99 96.03 315.99 45.25"
              />
              <line class="st5" x1="362.7" y1="53.39" x2="367.62" y2="96.03" />
              <polyline
                class="st5"
                points="386.27 96.03 409.29 96.03 452.94 90.91 467.41 88.85 469.38 102.56"
              />
              <polyline
                class="st5"
                points="436.76 92.81 431.98 53.55 478.79 47.69 485.2 100.47 454.79 104.49"
              />
              <polyline
                class="st5"
                points="450.41 71.53 457.5 124.25 457.5 128.68 459.17 128.68 459.17 137.72 495.19 137.72 495.19 100.2 485.2 22.37"
              />
              <line
                class="st5"
                x1="457.5"
                y1="124.25"
                x2="495.19"
                y2="119.91"
              />
              <line class="st5" x1="434.43" y1="73.64" x2="481.19" y2="67.45" />
              <polyline
                class="st5"
                points="467.41 88.85 466.85 84.57 482.98 82.2"
              />
              <polyline
                class="st5"
                points="495.19 100.2 532.34 95.89 624.05 95.89"
              />
              <line class="st5" x1="547.39" y1="14.65" x2="557.81" y2="95.89" />
              <rect
                class="st6"
                x="618.46"
                y="47.78"
                width="17.38"
                height="58.38"
                transform="translate(7.81 202.11) rotate(-18.42)"
              />
              <rect
                class="st6"
                x="634.55"
                y="39.71"
                width="34.18"
                height="58.38"
                transform="translate(11.62 209.43) rotate(-18.42)"
              />
              <rect
                class="st6"
                x="667.44"
                y="31.88"
                width="14.84"
                height="58.38"
                transform="translate(15.28 216.37) rotate(-18.42)"
              />
              <polygon
                class="st5"
                points="717.63 77.64 691.14 86.46 674.73 37.2 701.21 28.35 717.63 77.64"
              />
              <polygon
                class="st5"
                points="730.42 31.78 722.39 34.46 718.43 22.59 701.21 28.35 717.63 77.64 742.9 69.22 730.42 31.78"
              />
              <polyline
                class="st5"
                points="596.75 95.89 596.75 62.76 613.26 62.76"
              />
              <line class="st5" x1="742.9" y1="69.22" x2="756.24" y2="64.78" />
              <rect
                class="st6"
                x="716.58"
                y="168.12"
                width="20.24"
                height="67.78"
                transform="translate(-26.6 239.97) rotate(-18.42)"
              />
              <rect
                class="st6"
                x="693.54"
                y="226.82"
                width="32.56"
                height="16.21"
                transform="translate(-37.86 236.32) rotate(-18.42)"
              />
              <rect
                class="st6"
                x="669.56"
                y="205.21"
                width="20.48"
                height="46.88"
                transform="translate(-37.42 226.52) rotate(-18.42)"
              />
              <rect
                class="st6"
                x="739.1"
                y="198.5"
                width="2.52"
                height="17.12"
                transform="translate(-27.49 244.55) rotate(-18.42)"
              />
              <rect
                class="st6"
                x="717.22"
                y="188.41"
                width="20.24"
                height="31.26"
                transform="translate(-27.21 240.28) rotate(-18.42)"
              />
              <rect
                class="st6"
                x="697.74"
                y="194.75"
                width="18.13"
                height="16.49"
                transform="translate(-27.93 233.74) rotate(-18.42)"
              />
              <rect
                class="st6"
                x="707.08"
                y="209.72"
                width="13.62"
                height="14.79"
                transform="translate(-32.03 236.7) rotate(-18.42)"
              />
            </g>
          </g>
          <g id="numbers">
            <g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M98.81,144.97c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M103.04,144.54c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM102.53,145.91c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M104.85,147.81c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM106.68,147.21c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M99.65,162.18c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M103.88,161.75c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM103.37,163.12c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M105.79,162.18c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M21.27,125.17c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M25.65,125.45c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM27.48,124.85c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                        />
                        <path
                          class="st0"
                          d="M31.64,122.18c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM31.13,123.55c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M21.95,146.53c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M26.54,143.97c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M28.83,146.81c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM30.66,146.21c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M22.79,163.74c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M27.38,161.18c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M29.76,161.18c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M22.18,180.99c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M26.77,178.43c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M28.17,180.99c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M22.12,200.51c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M26.71,197.95c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M28.61,200.71c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M22.13,217.72c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M26.72,215.16c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M31.47,216.78v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM30.26,215.35c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M22.15,234.94c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M26.74,232.38c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M28.73,235.18c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M22.11,254.59c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M26.7,252.03c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M31,252.79c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM30.6,254.43c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M22.38,272.07c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M26.97,269.51c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M29.07,272.43c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M22.09,289.56c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M26.68,287c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M31.18,288.33c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM30.59,289.48c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM28.97,287.47c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M22.11,309.21c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M26.7,306.65c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M30.93,306.22c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM30.42,307.59c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M21.35,326.42c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M24.97,326.42c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M29.35,326.71c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM31.18,326.11c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M22.18,343.66c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M25.8,343.66c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M30.38,341.1c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M21.58,364.59c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M25.2,364.59c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M28.82,364.59c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M21.51,384.66c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M25.13,384.66c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M29.19,384.86c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M21.53,405.72c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M25.15,405.72c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M31.98,404.78v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM30.77,403.35c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M21.55,423.21c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M25.17,423.21c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M29.32,423.45c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M21.5,440.69c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M25.12,440.69c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M31.51,438.89c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM31.11,440.53c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M21.77,460.79c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M25.39,460.79c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M29.54,461.15c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M21.49,478.92c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M25.11,478.92c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M31.72,477.69c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM31.13,478.84c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM29.51,476.83c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M21.5,499.86c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M25.12,499.86c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M31.53,496.87c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM31.02,498.24c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M21.28,519.07c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M25.34,519.27c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st0"
                          d="M29.46,519.35c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM31.29,518.75c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M99.04,179.43c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M103.27,179c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM102.76,180.37c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M104.19,181.99c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M98.97,198.95c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M103.2,198.52c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM102.69,199.89c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M104.63,201.71c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M98.99,216.16c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M103.22,215.73c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM102.71,217.1c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M107.5,217.78v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM106.29,216.35c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M99.01,233.38c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M103.24,232.95c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM102.73,234.32c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M104.76,236.18c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M98.97,253.03c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M103.2,252.6c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM102.69,253.97c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M107.02,253.79c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM106.62,255.43c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M99.24,270.51c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M103.47,270.08c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM102.96,271.45c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M104.92,273.43c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M98.95,288c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M103.18,287.57c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM102.67,288.94c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M107.2,289.33c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM106.61,290.48c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM104.99,288.47c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M98.96,307.65c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M103.19,307.22c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM102.68,308.59c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M106.94,307.22c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM106.43,308.59c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M97.07,327.42c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M101.45,327.71c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM103.28,327.11c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M105.51,327.71c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM107.34,327.11c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M97.9,344.66c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M102.28,344.94c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM104.11,344.34c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M106.43,342.1c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M136.63,198.95c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M141.13,200.28c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.54,201.43c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM138.92,199.42c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M142.69,201.79c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM144.53,201.19c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M137.46,216.16c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M141.96,217.49c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM141.37,218.64c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.75,216.63c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M143.62,216.16c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M136.86,233.38c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M141.36,234.71c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.77,235.86c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.15,233.85c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M141.98,235.94c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M136.79,253.03c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M141.29,254.36c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.7,255.51c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.08,253.5c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M142.47,255.79c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M136.81,270.51c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M141.31,271.84c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.72,272.99c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.1,270.98c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M145.37,272.13v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM144.16,270.7c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M136.83,288c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M141.33,289.33c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.74,290.48c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.12,288.47c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M142.6,290.8c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M136.78,307.65c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M141.28,308.98c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.69,310.13c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.07,308.12c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M144.86,308.41c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM144.45,310.05c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M137.05,324.87c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M141.55,326.2c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.96,327.35c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.34,325.34c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M142.8,327.79c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M136.77,342.1c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M141.27,343.43c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.68,344.58c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.06,342.57c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M145.05,343.43c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM144.46,344.58c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM142.83,342.57c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.39,198.95c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M215.69,199.71c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM215.29,201.35c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M217.17,201.87c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.11,216.16c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M215.41,216.92c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM215.01,218.56c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M219.36,217.49c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM218.77,218.64c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM217.14,216.63c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.12,233.38c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M215.42,234.14c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM215.02,235.78c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M219.07,232.95c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM218.56,234.32c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.15,144.93c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M215.45,145.69c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM215.05,147.33c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M219.67,146.55v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM218.46,145.12c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.17,162.18c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M215.47,162.94c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM215.07,164.58c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M216.91,164.98c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.2,106.42c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M215.5,107.18c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM215.1,108.82c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M216.32,108.98c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.13,124.84c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M215.43,125.6c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM215.03,127.24c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M216.78,127.6c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.12,179.44c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M215.42,180.2c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM215.02,181.84c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M219.17,180.2c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM218.77,181.84c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.24,253.03c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M213.34,255.95c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M216.57,255.87c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM218.4,255.27c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M212.07,270.51c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M214.17,273.43c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M217.67,270.51c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.47,288c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M213.57,290.92c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M215.94,290.56c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.4,307.65c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M213.5,310.57c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M216.39,310.41c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.42,324.87c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M213.52,327.79c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M219.03,326.49v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM217.82,325.06c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M211.44,342.1c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M213.54,345.02c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M216.51,344.9c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.27,198.95c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M254.03,200.57v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM252.82,199.14c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M257.27,199.71c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM256.87,201.35c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.53,216.16c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M254.29,217.78v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM253.08,216.35c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M255.2,219.08c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.25,233.38c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M254.01,235v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM252.8,233.57c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M257.45,234.71c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM256.86,235.86c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM255.23,233.85c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.27,144.93c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M254.03,146.55v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM252.82,145.12c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M254.87,147.69c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.29,162.18c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M254.05,163.8v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM252.84,162.37c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M257.9,163.8v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM256.69,162.37c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.94,106.42c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M254.7,108.04v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM253.49,106.61c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M255.98,106.42c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.34,124.84c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M254.1,126.46v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM252.89,125.03c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M254.44,127.4c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.31,179.44c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M254.07,181.06v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM252.86,179.63c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M255,182.24c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.26,253.03c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M254.02,254.65v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM252.81,253.22c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M257.19,252.6c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM256.67,253.97c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.13,270.51c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M251.13,273.31c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M255.05,273.35c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM256.88,272.75c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.97,288c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M251.97,290.8c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M255.95,288c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.36,307.65c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M251.36,310.45c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M254.41,310.21c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.3,324.87c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M251.3,327.67c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M254.86,327.63c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.31,342.1c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M251.31,344.9c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M257.72,343.72v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM256.51,342.29c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.31,198.95c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M324.71,201.51c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M328.86,201.75c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.26,216.16c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M324.66,218.72c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M331.05,216.92c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM330.65,218.56c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.53,233.38c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M324.93,235.94c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M329.08,236.3c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.34,144.93c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M324.74,147.49c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M328.36,147.49c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.27,162.18c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M324.67,164.74c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M328.73,164.94c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.11,106.42c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M324.51,108.98c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M328.89,109.26c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM330.72,108.66c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M280.33,73.69c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M282.71,73.69c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M287.22,75.02c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM286.63,76.17c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM285.01,74.16c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M302.06,73.69c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M304.44,73.69c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M308.68,73.26c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM308.17,74.63c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.94,124.84c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M325.34,127.4c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M329.92,124.84c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M552.53,107.67c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM552.12,109.31c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M556.75,108.53v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM555.54,107.1c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M552.52,125.76c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM552.11,127.4c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M553.87,127.76c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M587.96,109.67c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M591.78,109.71c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.16.11-.29.28-.38.5l-.49-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M587.92,127.76c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M594.05,125.76c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM593.64,127.4c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.29,179.44c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M324.69,182c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M331.52,181.06v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM330.31,179.63c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.25,253.03c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M324.65,255.59c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M331.26,254.36c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM330.67,255.51c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM329.05,253.5c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.26,270.51c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M324.66,273.07c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M331.06,270.08c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM330.55,271.45c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.04,288c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M324.95,290.76c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M329.06,290.84c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM330.89,290.24c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.88,307.65c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M325.79,310.41c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M329.99,307.65c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.27,324.87c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M325.18,327.63c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M328.4,327.42c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.2,342.1c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M325.11,344.86c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M328.83,344.86c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M361.34,198.95c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M363.63,201.79c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM365.46,201.19c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M366.75,201.51c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M361.27,216.16c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M363.56,219c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM365.39,218.4c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M367.21,218.92c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M361.29,233.38c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M363.58,236.22c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM365.41,235.62c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M370.1,235v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM368.89,233.57c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M364.45,144.5c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM363.94,145.87c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M368.2,144.5c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM367.69,145.87c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M361.11,162.18c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M363.4,165.02c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM365.23,164.42c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M367.46,165.02c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM369.29,164.42c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M364.72,105.99c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM364.21,107.36c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M366.18,109.34c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M364.44,124.41c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM363.93,125.78c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M368.47,126.17c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM367.88,127.32c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM366.25,125.31c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M361.94,179.44c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M364.23,182.28c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM366.06,181.68c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M368.38,179.44c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M361.31,253.03c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M363.6,255.87c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM365.43,255.27c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M367.34,255.83c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M361.27,270.51c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M363.56,273.35c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM365.39,272.75c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M369.63,271.27c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM369.22,272.91c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M361.53,288c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M363.82,290.84c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM365.65,290.24c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M367.49,290.92c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M361.25,307.65c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M363.54,310.49c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM365.37,309.89c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M369.81,308.98c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM369.22,310.13c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM367.59,308.12c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M361.26,324.87c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M363.55,327.71c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM365.38,327.11c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M369.54,324.44c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM369.03,325.81c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M361.94,342.1c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M364.32,342.1c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M366.62,344.94c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM368.45,344.34c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M440.86,200.28c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM440.27,201.43c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM438.64,199.42c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M442.51,198.95c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M440.25,217.49c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM439.66,218.64c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM438.03,216.63c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M440.87,218.72c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.39-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M440.19,234.71c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM439.6,235.86c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM437.97,233.85c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M441.36,236.14c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M438.04,147.85c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M443.51,146.26c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM442.93,147.41c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM441.3,145.4c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M430.57,118.99c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M433.95,118.99c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M438.05,165.1c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M443.33,161.75c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM442.82,163.12c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M440.02,180.77c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM439.43,181.92c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM437.8,179.91c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M441.58,182.28c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM443.41,181.68c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42-.32.67-.32,1.16.11.89.32,1.17.51.43.9.43.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M440.2,254.36c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM439.61,255.51c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM437.98,253.5c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M444.25,254.65v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM443.04,253.22c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M440.22,271.84c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM439.63,272.99c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM438,270.98c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M441.48,273.31c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M440.18,289.33c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM439.59,290.48c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM437.96,288.47c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M443.75,288.76c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM443.35,290.4c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M440.45,308.98c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM439.86,310.13c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM438.23,308.12c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M441.69,310.57c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M440.16,326.2c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM439.57,327.35c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM437.94,325.34c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M443.93,326.2c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM443.34,327.35c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM441.71,325.34c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M440.17,343.43c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM439.58,344.58c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM437.95,342.57c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M443.67,341.67c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM443.16,343.04c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M477.54,199.71c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM477.13,201.35c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M481.48,200.28c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM480.89,201.43c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM479.27,199.42c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M477.55,216.92c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM477.14,218.56c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M481.2,215.73c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43s.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM480.69,217.1c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23-.28.36-.28.62.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M475.46,236.3c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M478.7,236.22c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25c.26.17.46.4.6.7s.21.65.21,1.06-.07.76-.21,1.07-.34.54-.6.71c-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM480.53,235.62c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16-.51-.43-.9-.43-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M477.6,145.69c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM477.19,147.33c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M479.04,147.73c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M477.56,162.94c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM477.15,164.58c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M481.3,162.94c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM480.9,164.58c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M477.83,180.2c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM477.42,181.84c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M479.3,182.36c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M476.3,255.95c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M479.81,253.03c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M475.69,273.43c0-.58.14-1.15.42-1.71.28-.56.68-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M478.07,273.07c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.39-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M475.62,290.92c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M478.51,290.76c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M475.64,310.57c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M481.15,309.27v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM479.94,307.84c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M475.66,327.79c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M478.63,327.67c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M475.62,345.02c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M480.86,342.86c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM480.45,344.5c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M550.24,201.75c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M556.12,198.52c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM555.61,199.89c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M550.23,218.96c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M556.39,217.49c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM555.8,218.64c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM554.17,216.63c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M550.51,236.18c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M554.15,236.3c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M552.58,145.69c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM552.17,147.33c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M553.4,147.49c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M553.19,162.94c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM552.78,164.58c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M555.01,162.18c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M552.35,180.2c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM551.94,181.84c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M554.08,182.28c-.26-.17-.46-.4-.6-.71s-.21-.66-.21-1.07.07-.75.21-1.06.34-.53.6-.7.57-.25.93-.25.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM555.91,181.68c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42-.32.67-.32,1.16.11.89.32,1.17.51.43.9.43.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M550.24,255.83c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M556.2,253.79c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM555.79,255.43c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M550.29,273.31c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M553.94,273.31c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M550.27,290.8c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M556.68,289.62v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM555.47,288.19c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M550.25,310.45c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M553.81,310.41c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M550.32,327.67c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.16.11-.29.28-.38.5l-.49-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M553.37,327.42c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.71.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M550.92,344.9c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M554.91,342.1c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M590.57,200.57v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM589.36,199.14c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M591.8,201.79c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25c.26.17.46.4.6.7s.21.65.21,1.06-.07.76-.21,1.07-.34.54-.6.71c-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM593.63,201.19c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16-.51-.43-.9-.43-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M591.4,217.78v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM590.19,216.35c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M592.69,216.16c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M590.8,235v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM589.59,233.57c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M591.14,235.94c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M588.12,147.69c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M591.83,147.85c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M587.84,164.94c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M594.17,163.51c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM593.58,164.66c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM591.95,162.65c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M622.46,134.71c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st0"
                          d="M629.04,133.57v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM627.83,132.14c0-.27,0-.47,0-.58h0c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M642.53,128.49c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st0"
                          d="M646.26,128.49c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M661.11,122.63c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st0"
                          d="M664.33,122.43c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M678.1,117.06c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st0"
                          d="M682.31,114.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M693.66,111.49c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st0"
                          d="M697.77,111.57c-.26-.17-.46-.4-.6-.71s-.21-.66-.21-1.07.07-.75.21-1.06.34-.53.6-.7.57-.25.93-.25.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM699.6,110.97c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42-.32.67-.32,1.16.11.89.32,1.17.51.43.9.43.69-.14.9-.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M712.47,103.54c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.71.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M718.88,100.55c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM718.37,101.92c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23-.28.36-.28.62.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M730.46,97.51c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M737.07,96.28c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM736.49,97.43c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM734.86,95.42c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M748.74,91.48c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.39-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M752.9,91.84c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M657.5,234.28c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M661.73,233.85c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM661.22,235.22c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M685.51,182.24c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M691.9,180.44c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM691.5,182.08c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M739.12,172.91c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M743.27,173.15c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M755.5,167.26c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M762.33,166.32v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM761.12,164.89c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M771.88,161.61c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M775.94,161.81c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M750.9,206.54c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.39-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M754.52,206.54c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.39-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M767.91,200.89c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M772.5,198.33c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M783.47,195.24c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.71.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st0"
                          d="M787.85,195.52c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM789.68,194.92c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M763.47,237.74c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M764.87,240.3c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.39-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M742.49,243.86c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M744.4,246.62c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M722.04,249.87c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M726.79,251.49v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM725.58,250.06c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M706.02,255.55c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M708.02,258.35c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M689.94,261.23c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M694.24,261.99c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM693.84,263.63c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M670.91,267.55c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M673.01,270.47c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M654.36,272.89c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M658.86,274.22c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM658.27,275.37c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM656.65,273.36c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M780.33,232.28c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M782.71,232.28c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M795.76,226.82c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st0"
                          d="M798.05,229.66c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25c.26.17.46.4.6.7s.21.65.21,1.06-.07.76-.21,1.07-.34.54-.6.71c-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM799.88,229.06c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16-.51-.43-.9-.43-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M788.52,310.82c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M806.86,302.69c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM806.45,304.33c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M821,299.41c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M798.51,342.98c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M781.16,348.54v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM779.95,347.11c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M769.77,315.75c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM769.18,316.9c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM767.55,314.89c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M734.17,316.17c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM733.66,317.54c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M814.47,336.81c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.71.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st0"
                          d="M832.46,328.93c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M587.85,182.2c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M593.9,179.01c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43s.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM593.39,180.38c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23-.28.36-.28.62.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M590.73,254.65v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM589.52,253.22c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M591.58,255.79c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M590.75,272.13v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM589.54,270.7c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M594.6,272.13v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM593.39,270.7c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M590.77,289.62v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM589.56,288.19c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M591.71,290.8c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M590.72,309.27v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM589.51,307.84c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M593.96,308.41c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM593.56,310.05c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M590.99,326.49v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM589.78,325.06c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M591.9,327.79c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M590.71,343.72v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM589.5,342.29c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M594.15,343.43c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM593.56,344.58c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM591.94,342.57c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M97.29,406.72c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M101.67,407c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM103.5,406.4c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M104.79,406.72c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M126.38,411.03c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M130.88,412.36c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM130.29,413.51c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM128.67,411.5c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st0"
                        d="M134.38,410.6c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM133.87,411.97c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M97.23,424.21c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M101.61,424.49c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM103.44,423.89c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M105.26,424.41c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M97.24,441.69c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M101.62,441.97c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM103.45,441.37c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M108.14,440.75v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM106.93,439.32c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M97.27,461.79c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M101.65,462.07c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM103.48,461.47c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M105.39,462.03c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M97.22,479.92c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M101.6,480.2c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM103.43,479.6c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M107.67,478.12c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM107.26,479.76c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M97.49,500.86c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M101.87,501.14c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM103.7,500.54c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M105.54,501.22c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M97.21,520.04c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M101.59,520.32c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25c.26.17.46.4.6.7s.21.65.21,1.06-.07.76-.21,1.07-.34.54-.6.71c-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM103.42,519.72c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16-.51-.43-.9-.43-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st0"
                        d="M107.86,518.81c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM107.27,519.96c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM105.64,517.95c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.33,404.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M251.33,407.19c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M254.98,407.19c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M203.57,413.36c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M205.67,416.28c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M209.05,416.28c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M221.11,413.36c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M223.21,416.28c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M228.44,414.12c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM228.04,415.76c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.28,422.34c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M251.28,425.14c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M257.24,423.1c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM256.83,424.74c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.55,442.84c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M251.55,445.64c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M255.19,445.76c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.26,460.6c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M251.26,463.4c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M257.41,461.93c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM256.83,463.08c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM255.2,461.07c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M212.75,442.84c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M214.85,445.76c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M220.32,444.17c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM219.73,445.32c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM218.11,443.31c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M212.76,460.6c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M214.86,463.52c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st0"
                        d="M220.14,460.17c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM219.62,461.54c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.28,480.73c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M251.28,483.53c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M257.16,480.3c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM256.65,481.67c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.08,498.63c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M253.38,499.39c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM252.98,501.03c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M255.12,501.47c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM256.95,500.87c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M249.91,516.53c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M254.21,517.29c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM253.81,518.93c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st0"
                        d="M256.04,516.53c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.21,404.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M325.12,407.15c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M331.69,406.01v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM330.48,404.58c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.23,422.34c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M325.14,425.1c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M328.96,425.14c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.19,442.84c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M325.1,445.6c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M331.22,443.6c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM330.82,445.24c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.46,460.6c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M325.37,463.36c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M329.08,463.52c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.17,480.73c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M325.08,483.49c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M331.4,482.06c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM330.81,483.21c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM329.19,481.2c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.18,498.63c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M325.09,501.39c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M331.14,498.2c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM330.63,499.57c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M323.05,516.53c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M327.81,518.15v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM326.6,516.72c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M329.04,519.37c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM330.87,518.77c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M362.77,404.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M365.15,404.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M367.54,404.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M362.16,422.34c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M364.54,422.34c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M365.95,424.9c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.39-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M362.1,442.84c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M364.48,442.84c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M366.39,445.6c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M362.11,460.6c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M364.49,460.6c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M369.25,462.22v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM368.04,460.79c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M362.14,480.73c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M364.52,480.73c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M366.52,483.53c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M362.09,498.63c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M364.47,498.63c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M368.78,499.39c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM368.38,501.03c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M362.36,516.53c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M364.74,516.53c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st0"
                        d="M366.85,519.45c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M439.75,403.96c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM439.24,405.33c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M441.57,407.23c-.26-.17-.46-.4-.6-.71s-.21-.66-.21-1.07.07-.75.21-1.06.34-.53.6-.7.57-.25.93-.25.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM443.4,406.63c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42-.32.67-.32,1.16.11.89.32,1.17.51.43.9.43.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M512.65,404.48c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st0"
                        d="M516.57,404.52c-.26-.17-.46-.4-.6-.71s-.21-.66-.21-1.07.07-.75.21-1.06.34-.53.6-.7.57-.25.93-.25.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM518.41,403.92c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42-.32.67-.32,1.16.11.89.32,1.17.51.43.9.43.69-.14.9-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M569.79,403.3v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM568.58,401.87c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st0"
                        d="M572.96,401.25c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM572.45,402.62c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.44-.24-.75-.24s-.56.08-.75.23-.28.36-.28.62.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M440.58,421.91c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM440.07,423.28c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M442.49,422.34c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M439.97,442.41c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43s.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM439.46,443.78c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23-.28.36-.28.62.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M440.89,445.4c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.39-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M439.91,460.17c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM439.4,461.54c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M441.34,463.36c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M439.92,480.3c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM439.41,481.67c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M444.2,482.35v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM442.99,480.92c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M439.95,498.2c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM439.44,499.57c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M441.47,501.43c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M439.9,516.1c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43s.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM439.39,517.47c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23-.28.36-.28.62.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st0"
                        d="M443.73,517.29c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM443.32,518.93c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.85,151.18c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M95.76,153.94c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M99.16,154.69c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M103.49,152.51c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM102.9,153.66c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM101.28,151.65c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M108.36,154.17h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.8,152.08c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.85,168.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M95.76,171.15c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M99.16,171.9c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M103.49,169.72c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM102.9,170.87c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM101.28,168.86c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M108.36,171.38h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.8,169.3c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.73,185.63c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M98.49,187.25v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM97.28,185.82c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M99.04,189.14c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M101.11,188.47c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM102.94,187.87c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M108.47,188.62h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.92,186.54c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.85,205.15c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M95.76,207.91c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M99.16,208.66c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M103.49,206.48c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM102.9,207.63c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM101.28,205.62c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M108.36,208.14h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.8,206.06c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.85,222.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M95.76,225.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M99.16,225.88c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M103.49,223.7c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM102.9,224.85c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM101.28,222.84c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M108.36,225.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.8,223.28c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.99,130.82c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M22.29,131.58c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM21.89,133.22c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                        />
                        <path
                          class="st1"
                          d="M23.31,134.33c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M24.74,133.38c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st1"
                          d="M32.54,133.81h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.77,131.72c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.91,152.18c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M19.82,154.94c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st1"
                          d="M23.22,155.69c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M27.55,153.51c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM26.96,154.66c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM25.34,152.65c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                        />
                        <path
                          class="st1"
                          d="M32.42,155.17h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.85,153.08c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.91,169.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M19.82,172.15c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st1"
                          d="M23.22,172.9c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M27.55,170.72c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM26.96,171.87c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM25.34,169.86c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                        />
                        <path
                          class="st1"
                          d="M32.42,172.38h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.85,170.3c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.78,186.63c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M22.54,188.25v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM21.33,186.82c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                        <path
                          class="st1"
                          d="M23.09,190.14c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M25.16,189.47c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM26.99,188.87c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                        />
                        <path
                          class="st1"
                          d="M32.52,189.62h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.98,187.54c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.91,206.15c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M19.82,208.91c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st1"
                          d="M23.22,209.66c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M27.55,207.48c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM26.96,208.63c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM25.34,206.62c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                        />
                        <path
                          class="st1"
                          d="M32.42,209.14h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.85,207.06c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.91,223.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M19.82,226.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st1"
                          d="M23.22,226.88c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M27.55,224.7c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM26.96,225.85c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM25.34,223.84c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                        />
                        <path
                          class="st1"
                          d="M32.42,226.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.85,224.28c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.91,240.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M19.82,243.35c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st1"
                          d="M23.22,244.1c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M27.55,241.92c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM26.96,243.07c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM25.34,241.06c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                        />
                        <path
                          class="st1"
                          d="M32.42,243.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.85,241.49c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.91,260.23c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M19.82,262.99c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st1"
                          d="M23.22,263.74c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M27.55,261.56c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM26.96,262.71c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM25.34,260.7c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                        />
                        <path
                          class="st1"
                          d="M32.42,263.22h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.85,261.14c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.91,277.72c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M19.82,280.48c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st1"
                          d="M23.22,281.23c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M27.55,279.05c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM26.96,280.2c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM25.34,278.19c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                        />
                        <path
                          class="st1"
                          d="M32.42,280.71h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.85,278.62c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.78,295.2c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M22.54,296.82v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM21.33,295.39c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                        <path
                          class="st1"
                          d="M23.09,298.71c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M25.16,298.04c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM26.99,297.44c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                        />
                        <path
                          class="st1"
                          d="M32.52,298.19h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.98,296.11c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.91,314.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M19.82,317.61c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st1"
                          d="M23.22,318.36c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M27.55,316.18c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM26.96,317.33c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM25.34,315.32c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                        />
                        <path
                          class="st1"
                          d="M32.42,317.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.85,315.76c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.78,332.08c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M22.54,333.7v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM21.33,332.27c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                        <path
                          class="st1"
                          d="M23.09,335.59c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M25.16,334.92c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.05c.14-.3.34-.54.6-.7.26-.17.57-.25.93-.25s.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.05s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM26.99,334.32c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.29-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                        />
                        <path
                          class="st1"
                          d="M32.52,335.07h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.98,332.98c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.78,349.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M22.54,350.92v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM21.33,349.49c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                        <path
                          class="st1"
                          d="M23.09,352.81c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M25.16,352.14c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM26.99,351.54c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                        />
                        <path
                          class="st1"
                          d="M32.52,352.29h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.98,350.21c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.99,370.24c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M22.29,371c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM21.89,372.64c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                        />
                        <path
                          class="st1"
                          d="M23.31,373.75c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M24.74,372.8c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st1"
                          d="M32.54,373.23h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.77,371.15c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.99,390.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M22.29,391.06c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM21.89,392.7c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                        />
                        <path
                          class="st1"
                          d="M23.31,393.81c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M24.74,392.86c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st1"
                          d="M32.54,393.29h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.77,391.21c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.91,411.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M19.82,414.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st1"
                          d="M23.22,414.88c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M27.55,412.7c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM26.96,413.85c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM25.34,411.84c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                        />
                        <path
                          class="st1"
                          d="M32.42,414.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.85,412.27c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.91,428.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M19.82,431.61c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                        />
                        <path
                          class="st1"
                          d="M23.22,432.36c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M27.55,430.18c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM26.96,431.33c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM25.34,429.32c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                        />
                        <path
                          class="st1"
                          d="M32.42,431.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.85,429.76c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.78,446.34c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M22.54,447.96v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM21.33,446.53c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                        <path
                          class="st1"
                          d="M23.09,449.85c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M25.16,449.18c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM26.99,448.58c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                        />
                        <path
                          class="st1"
                          d="M32.52,449.33h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.98,447.24c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.98,466.43c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M22.74,468.05v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM21.53,466.62c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                        <path
                          class="st1"
                          d="M23.29,469.94c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M25.16,469.23c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                        />
                        <path
                          class="st1"
                          d="M32.42,469.42h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.78,467.34c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.98,484.56c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M22.74,486.18v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM21.53,484.75c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                        <path
                          class="st1"
                          d="M23.29,488.07c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M25.16,487.36c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                        />
                        <path
                          class="st1"
                          d="M32.42,487.55h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.78,485.47c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.93,505.51c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M22.69,507.13v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM21.48,505.7c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                        <path
                          class="st1"
                          d="M23.24,509.02c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M27.31,505.08c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM26.8,506.45c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                        />
                        <path
                          class="st1"
                          d="M32.44,508.5h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.83,506.41c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M17.93,524.71c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                        />
                        <path
                          class="st1"
                          d="M22.69,526.33v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM21.48,524.9c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                        />
                        <path
                          class="st1"
                          d="M23.24,528.22c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M27.31,524.28c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM26.8,525.65c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                        />
                        <path
                          class="st1"
                          d="M32.44,527.7h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M34.83,525.62c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.85,239.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M95.76,242.35c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M99.16,243.1c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M103.49,240.92c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM102.9,242.07c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM101.28,240.06c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M108.36,242.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.8,240.49c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.85,259.23c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M95.76,261.99c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M99.16,262.74c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M103.49,260.56c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM102.9,261.71c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM101.28,259.7c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M108.36,262.22h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.8,260.14c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.85,276.72c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M95.76,279.48c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M99.16,280.23c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M103.49,278.05c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM102.9,279.2c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM101.28,277.19c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M108.36,279.71h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.8,277.62c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.73,294.2c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M98.49,295.82v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM97.28,294.39c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M99.04,297.71c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M101.11,297.04c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM102.94,296.44c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M108.47,297.19h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.92,295.11c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.91,313.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M95.82,316.61c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M99.22,317.36c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M101.09,316.65c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M108.35,316.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.74,314.76c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.73,331.08c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M98.49,332.7v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM97.28,331.27c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M99.04,334.59c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M101.11,333.92c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.05c.14-.3.34-.54.6-.7.26-.17.57-.25.93-.25s.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.05s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM102.94,333.32c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.29-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M108.47,334.07h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.92,331.98c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.73,348.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M98.49,349.92v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM97.28,348.49c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M99.04,351.81c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M101.11,351.14c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM102.94,350.54c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M108.47,351.29h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.92,349.21c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M131.68,205.15c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M133.59,207.91c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M136.99,208.66c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M141.32,206.48c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.73,207.63c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.11,205.62c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M146.19,208.14h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M148.63,206.06c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M131.68,222.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M133.59,225.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M136.99,225.88c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M141.32,223.7c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.73,224.85c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.11,222.84c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M146.19,225.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M148.63,223.28c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M131.68,239.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M133.59,242.35c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M136.99,243.1c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M141.32,240.92c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.73,242.07c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.11,240.06c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M146.19,242.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M148.63,240.49c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M131.68,259.23c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M133.59,261.99c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M136.99,262.74c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M141.32,260.56c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.73,261.71c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.11,259.7c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M146.19,262.22h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M148.63,260.14c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M131.68,276.72c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M133.59,279.48c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M136.99,280.23c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M141.32,278.05c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM140.73,279.2c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM139.11,277.19c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M146.19,279.71h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M148.63,277.62c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M131.56,294.2c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M136.32,295.82v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM135.11,294.39c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M136.87,297.71c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M138.94,297.04c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM140.77,296.44c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M146.3,297.19h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M148.75,295.11c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M131.74,313.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M133.65,316.61c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M137.04,317.36c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M138.92,316.65c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M146.18,316.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M148.57,314.76c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M131.56,331.08c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M136.32,332.7v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM135.11,331.27c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M136.87,334.59c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M138.94,333.92c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.05c.14-.3.34-.54.6-.7.26-.17.57-.25.93-.25s.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.05s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM140.77,333.32c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.29-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M146.3,334.07h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M148.75,331.98c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M131.56,348.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M136.32,349.92v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM135.11,348.49c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M136.87,351.81c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M138.94,351.14c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM140.77,350.54c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M146.3,351.29h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M148.75,349.21c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M206,205.15c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M207.91,207.91c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M211.31,208.66c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M215.64,206.48c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM215.05,207.63c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM213.43,205.62c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M220.51,208.14h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M222.95,206.06c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M206,222.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M207.91,225.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M211.31,225.88c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M215.64,223.7c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM215.05,224.85c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM213.43,222.84c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M220.51,225.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M222.95,223.28c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M206,239.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M207.91,242.35c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M211.31,243.1c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M215.64,240.92c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM215.05,242.07c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM213.43,240.06c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M220.51,242.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M222.95,240.49c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M206,151.13c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M207.91,153.89c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M211.31,154.64c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M215.64,152.46c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM215.05,153.61c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM213.43,151.6c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M220.51,154.12h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M222.95,152.04c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M206,168.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M207.91,171.15c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M211.31,171.9c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M215.64,169.72c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM215.05,170.87c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM213.43,168.86c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M220.51,171.38h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M222.95,169.3c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M206.03,112.63c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M210.79,114.25v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM209.58,112.82c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M211.34,116.14c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M215.4,113.39c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM215,115.03c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M220.44,115.62h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M222.92,113.53c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M206.74,131.05c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M208.74,133.85c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M211.95,134.56c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M213.9,131.05c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M219.5,134.04h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M222.22,131.95c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M205.88,185.64c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M210.64,187.26v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM209.43,185.83c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M211.19,189.15c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M213.26,188.48c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM215.09,187.88c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M220.62,188.63h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M223.08,186.55c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M206,259.23c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M207.91,261.99c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M211.31,262.74c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M215.64,260.56c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM215.05,261.71c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM213.43,259.7c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M220.51,262.22h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M222.95,260.14c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M206,276.72c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M207.91,279.48c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M211.31,280.23c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M215.64,278.05c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM215.05,279.2c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM213.43,277.19c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M220.51,279.71h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M222.95,277.62c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M207.15,294.2c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M209.25,297.12c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M211.62,296.76c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M219.42,297.19h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M221.81,295.11c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M206.06,313.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M207.97,316.61c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M211.37,317.36c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M213.24,316.65c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M220.5,316.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M222.89,314.76c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M205.88,331.08c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M210.64,332.7v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM209.43,331.27c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M211.19,334.59c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M213.26,333.92c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.05c.14-.3.34-.54.6-.7.26-.17.57-.25.93-.25s.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.05s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM215.09,333.32c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.29-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M220.62,334.07h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M223.08,331.98c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M205.88,348.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M210.64,349.92v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM209.43,348.49c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M211.19,351.81c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M213.26,351.14c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM215.09,350.54c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M220.62,351.29h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M223.08,349.21c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.14,205.15c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.05,207.91c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M249.45,208.66c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M253.5,205.91c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM253.1,207.55c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M258.55,208.14h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.06,206.06c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.14,222.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.05,225.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M249.45,225.88c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M253.5,223.13c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM253.1,224.77c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M258.55,225.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.06,223.28c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.13,239.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.04,242.35c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M249.44,243.1c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M253.51,239.16c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM253,240.53c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M258.63,242.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.06,240.49c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.14,151.13c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.05,153.89c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M249.45,154.64c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M253.5,151.89c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM253.1,153.53c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M258.55,154.12h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.06,152.04c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.14,168.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.05,171.15c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M249.45,171.9c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M253.5,169.15c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM253.1,170.79c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M258.55,171.38h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.06,169.3c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.42,112.63c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M249.18,114.25v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM247.97,112.82c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M249.73,116.14c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M251.42,115.55c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M258.13,115.62h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M260.77,113.53c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.02,131.05c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.02,133.85c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M249.23,134.56c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M251.29,133.89c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM253.13,133.29c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M258.66,134.04h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.17,131.95c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.13,185.64c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.04,188.4c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M249.44,189.15c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M253.51,185.21c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM253,186.58c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M258.63,188.63h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.06,186.55c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.14,259.23c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.05,261.99c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M249.45,262.74c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M253.5,259.99c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM253.1,261.63c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M258.55,262.22h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.06,260.14c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.14,276.72c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.05,279.48c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M249.45,280.23c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M253.5,277.48c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM253.1,279.12c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M258.55,279.71h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.06,277.62c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.13,294.2c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.04,296.96c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M249.44,297.71c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M253.51,293.77c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM253,295.14c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M258.63,297.19h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.06,295.11c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.14,313.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.05,316.61c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M249.45,317.36c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M253.5,314.61c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM253.1,316.25c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M258.55,316.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.06,314.76c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.14,331.08c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.05,333.84c-.29-.22-.45-.51-.48-.88l.51-.06c.03.27.15.47.34.62.19.15.46.22.8.22s.6-.06.78-.19c.18-.13.26-.31.26-.55,0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.49,0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.32Z"
                      />
                      <path
                        class="st1"
                        d="M249.45,334.59c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M253.5,331.84c.25.23.38.55.38.97,0,.26-.06.5-.19.7s-.3.37-.53.48c-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.37.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM253.1,333.48c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.16.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M258.55,334.07h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.06,331.98c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.13,348.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M246.04,351.06c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M249.44,351.81c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M253.51,347.87c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM253,349.24c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M258.63,351.29h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M261.06,349.21c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.17,205.15c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.93,206.77v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.72,205.34c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.48,208.66c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M324.91,207.71c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M332.71,208.14h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.91,206.06c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.08,222.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M319.99,225.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M323.39,225.88c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M327.46,221.94c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM326.95,223.31c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M332.58,225.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M335.01,223.28c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.08,239.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M319.99,242.35c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M323.39,243.1c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M327.46,239.16c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM326.95,240.53c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M332.58,242.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M335.01,240.49c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.08,151.13c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M319.99,153.89c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M323.39,154.64c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M327.44,151.89c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM327.04,153.53c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M332.49,154.12h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M335,152.04c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.08,168.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M319.99,171.15c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M323.39,171.9c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M327.44,169.15c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM327.04,170.79c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M332.49,171.38h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M335,169.3c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.1,112.63c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.86,114.25v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.65,112.82c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.41,116.14c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M327.48,112.2c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM326.97,113.57c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M332.61,115.62h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.99,113.53c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M274.9,80.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M277,83.29c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M279.2,83.88c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M280.63,82.93c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M288.43,83.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M291.15,81.28c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M296.54,80.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M298.64,83.29c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M300.84,83.88c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M304.9,81.13c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM304.49,82.77c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M309.94,83.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M312.94,81.28c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.13,131.05c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M320.13,133.85c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M323.34,134.56c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M325.12,133.81c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M332.54,134.04h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.96,131.95c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.55,113.11c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.65,116.03c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M548.85,116.62c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M552.91,113.87c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM552.5,115.51c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M557.95,116.1h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M560.95,114.02c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.58,131.21c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M549.33,132.83v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM548.12,131.4c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M549.89,134.72c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M551.58,134.13c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M558.29,134.2h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M560.92,132.12c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.08,113.11c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M586.58,114.44c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM585.99,115.59c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM584.37,113.58c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M587.43,116.62c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M589.21,115.87c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M596.64,116.1h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M599.02,114.02c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.14,131.21c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M584.14,134.01c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M587.35,134.72c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M589.13,133.97c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M596.55,134.2h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.96,132.12c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.12,185.64c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.88,187.26v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.67,185.83c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.43,189.15c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M328,187.26v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM326.79,185.83c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M332.54,188.63h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.96,186.55c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.17,259.23c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.93,260.85v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.72,259.42c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.48,262.74c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M324.91,261.79c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M332.71,262.22h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.91,260.14c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.08,276.72c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M319.99,279.48c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M323.39,280.23c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M327.44,277.48c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM327.04,279.12c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M332.49,279.71h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M335,277.62c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.17,294.2c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.93,295.82v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.72,294.39c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.48,297.71c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M324.91,296.76c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M332.71,297.19h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.91,295.11c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.17,313.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.93,315.47v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.72,314.04c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.48,317.36c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M324.91,316.41c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M332.71,316.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.91,314.76c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.17,331.08c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.93,332.7v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.72,331.27c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.48,334.59c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M324.91,333.64c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22-.26.34-.26.59c0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.77-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M332.71,334.07h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.91,331.98c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.08,348.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M319.99,351.06c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M323.39,351.81c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M327.44,349.06c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35ZM327.04,350.7c.18-.17.27-.4.27-.68s-.09-.5-.26-.66c-.17-.16-.42-.23-.74-.23-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.17.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M332.49,351.29h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M335,349.21c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.58,205.15c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.49,207.91c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M361.89,208.66c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M363.58,208.07c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M370.29,208.14h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M372.97,206.06c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.34,222.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.25,225.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M361.65,225.88c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M366.22,223.99v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM365.01,222.56c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M370.76,225.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M373.21,223.28c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.34,239.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.25,242.35c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M361.65,243.1c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M366.22,241.21v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM365.01,239.78c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M370.76,242.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M373.21,240.49c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.99,151.13c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.9,153.89c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M362.29,154.64c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M364.25,151.13c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M369.85,154.12h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M372.55,152.04c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.99,168.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.9,171.15c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M362.29,171.9c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M364.25,168.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M369.85,171.38h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M372.55,169.3c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.36,112.63c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M361.12,114.25v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM359.91,112.82c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M361.67,116.14c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M366.24,114.25v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM365.03,112.82c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M370.78,115.62h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M373.19,113.53c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.6,131.05c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M361.36,132.67v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM360.15,131.24c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M361.91,134.56c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M363.6,133.97c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M370.31,134.04h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M372.95,131.95c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.31,185.64c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.22,188.4c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M361.62,189.15c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M365.69,185.21c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM365.18,186.58c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M370.81,188.63h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M373.24,186.55c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.58,259.23c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.49,261.99c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M361.89,262.74c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M363.58,262.15c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M370.29,262.22h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M372.97,260.14c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.99,276.72c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.9,279.48c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M362.29,280.23c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M364.25,276.72c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M369.85,279.71h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M372.56,277.62c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.58,294.2c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.49,296.96c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M361.89,297.71c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M363.58,297.12c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M370.29,297.19h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M372.97,295.11c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.58,313.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.49,316.61c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M361.89,317.36c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M363.58,316.77c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M370.29,316.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M372.97,314.76c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.58,331.08c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.49,333.84c-.29-.22-.45-.51-.48-.88l.51-.06c.03.27.15.47.34.62.19.15.46.22.8.22s.6-.06.78-.19c.18-.13.26-.31.26-.55,0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.49,0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.32Z"
                      />
                      <path
                        class="st1"
                        d="M361.89,334.59c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M363.58,334c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.98-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M370.29,334.07h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M372.97,331.98c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.99,348.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.9,351.06c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M362.29,351.81c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M364.25,348.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M369.85,351.29h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M372.56,349.21c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.76,205.15c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M433.67,207.91c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M437.07,208.66c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M441.4,206.48c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM440.81,207.63c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM439.19,205.62c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M446.27,208.14h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.71,206.06c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.82,222.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.44v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M433.73,225.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M437.12,225.88c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M439,225.17c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M446.26,225.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.65,223.28c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.82,239.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.44v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M433.73,242.35c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M437.12,243.1c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M439,242.39c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M446.26,242.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.65,240.49c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.62,151.13c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M433.53,153.89c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M436.92,154.64c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M438.99,153.97c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25c.26.17.46.4.6.7s.21.65.21,1.06-.07.76-.21,1.07-.34.54-.6.71c-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM440.83,153.37c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16-.51-.43-.9-.43-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M446.36,154.12h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.85,152.04c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13c-.17,0-.31.04-.41.13s-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25.13-.06.29-.09.46-.09.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <path
                  class="st1"
                  d="M428.4,122.27c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.49h.44v3.82h-.51v-2.99h0Z"
                />
                <path
                  class="st1"
                  d="M432.7,123.04c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51.71-.53,1.25-.53c.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35h-.02ZM432.3,124.68c.18-.17.27-.4.27-.68s-.09-.5-.26-.66-.42-.23-.74-.23c-.3,0-.54.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26c0,0,.01,0,.01,0Z"
                />
                <path
                  class="st1"
                  d="M433.72,125.78c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                />
                <path
                  class="st1"
                  d="M435.15,124.83c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22-.26.34-.26.59c0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34s.37.52.37.89c0,.27-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.45h.01Z"
                />
                <path
                  class="st1"
                  d="M432.06,131.27h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h0Z"
                />
                <path
                  class="st1"
                  d="M434.32,129.18c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25c.13-.06.29-.09.46-.09.28,0,.49.07.63.2s.22.3.22.52c0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.26.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                />
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.78,168.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.44v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M433.69,171.15c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M437.08,171.9c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M438.87,171.15c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M446.29,171.38h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.68,169.3c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.8,185.64c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M436.56,187.26v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM435.35,185.83c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M437.11,189.15c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M438.89,188.4c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M446.32,188.63h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.67,186.55c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.76,259.23c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M433.67,261.99c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M437.07,262.74c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M441.4,260.56c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM440.81,261.71c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM439.19,259.7c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M446.27,262.22h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.71,260.14c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.82,276.72c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.44v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M433.73,279.48c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M437.12,280.23c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M439,279.52c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M446.26,279.71h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.65,277.62c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.82,294.2c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.44v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M433.73,296.96c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M437.12,297.71c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M439,297c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M446.26,297.19h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.65,295.11c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.76,313.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M433.67,316.61c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M437.07,317.36c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M441.4,315.18c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM440.81,316.33c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM439.19,314.32c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M446.27,316.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.71,314.76c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.76,331.08c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M433.67,333.84c-.29-.22-.45-.51-.48-.88l.51-.06c.03.27.15.47.34.62s.46.22.8.22.6-.06.78-.19c.18-.13.26-.31.26-.55,0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.49c0-.2-.08-.36-.25-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.32Z"
                      />
                      <path
                        class="st1"
                        d="M437.07,334.59c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M441.4,332.41c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29-.29-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64s.38-.29.68-.36c-.27-.09-.46-.21-.59-.36s-.19-.34-.19-.56c0-.2.06-.37.19-.52s.3-.27.53-.35c.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM440.81,333.56c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM439.19,331.55c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.26-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M446.27,334.07h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2s-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.71,331.98c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.62,348.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M433.53,351.06c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M436.92,351.81c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M438.99,351.14c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25c.26.17.46.4.6.7s.21.65.21,1.06-.07.76-.21,1.07-.34.54-.6.71c-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM440.83,350.54c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16-.51-.43-.9-.43-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M446.36,351.29h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.85,349.21c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13c-.17,0-.31.04-.41.13s-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25.13-.06.29-.09.46-.09.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M469.33,205.15c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M471.24,207.91c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M474.63,208.66c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M478.97,206.48c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM478.38,207.63c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM476.76,205.62c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M483.84,208.14h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M486.27,206.06c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M469.33,222.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M471.24,225.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M474.63,225.88c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M478.97,223.7c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM478.38,224.85c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM476.76,222.84c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M483.84,225.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M486.27,223.28c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M469.2,239.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M473.96,241.21v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM472.75,239.78c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M474.51,243.1c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M476.58,242.43c-.26-.17-.46-.4-.6-.71s-.21-.66-.21-1.07.07-.75.21-1.06.34-.53.6-.7.57-.25.93-.25.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM478.41,241.83c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42-.32.67-.32,1.16.11.89.32,1.17.51.43.9.43.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M483.94,242.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M486.4,240.49c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M469.32,151.13c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M471.23,153.89c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M474.62,154.64c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M478.96,152.46c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM478.37,153.61c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM476.75,151.6c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M483.83,154.12h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M486.27,152.04c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M469.32,168.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M471.23,171.15c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M474.62,171.9c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M478.96,169.72c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM478.37,170.87c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM476.75,168.86c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M483.83,171.38h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M486.27,169.3c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M469.2,185.64c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M473.96,187.26v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM472.75,185.83c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M474.51,189.15c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M476.58,188.48c-.26-.17-.46-.4-.6-.71s-.21-.66-.21-1.07.07-.75.21-1.06.34-.53.6-.7.57-.25.93-.25.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM478.41,187.88c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42-.32.67-.32,1.16.11.89.32,1.17.51.43.9.43.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M483.94,188.63h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M486.4,186.55c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M469.33,259.23c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M471.24,261.99c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M474.63,262.74c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M478.97,260.56c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM478.38,261.71c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM476.76,259.7c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M483.84,262.22h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M486.27,260.14c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M469.33,276.72c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M471.24,279.48c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M474.63,280.23c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M478.97,278.05c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35s.49-.12.8-.12.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM478.38,279.2c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM476.76,277.19c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46-.17-.11-.41-.16-.73-.16s-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M483.84,279.71h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M486.27,277.62c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M469.2,294.2c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M473.96,295.82v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM472.75,294.39c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M474.51,297.71c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M476.58,297.04c-.26-.17-.46-.4-.6-.71s-.21-.66-.21-1.07.07-.75.21-1.06.34-.53.6-.7.57-.25.93-.25.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM478.41,296.44c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42-.32.67-.32,1.16.11.89.32,1.17.51.43.9.43.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M483.94,297.19h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M486.4,295.11c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M469.2,313.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M473.96,315.47v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM472.75,314.04c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M474.51,317.36c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M476.58,316.69c-.26-.17-.46-.4-.6-.71s-.21-.66-.21-1.07.07-.75.21-1.06.34-.53.6-.7.57-.25.93-.25.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM478.41,316.09c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42-.32.67-.32,1.16.11.89.32,1.17.51.43.9.43.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M483.94,316.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M486.4,314.76c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M469.39,331.08c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M471.3,333.84c-.29-.22-.45-.51-.48-.88l.51-.06c.03.27.15.47.34.62s.46.22.8.22.6-.06.78-.19c.18-.13.26-.31.26-.55,0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.49c0-.2-.08-.36-.25-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.32Z"
                      />
                      <path
                        class="st1"
                        d="M474.7,334.59c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M476.57,333.88c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53s.41.19.69.19c.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.16s-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.14.72-.14.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M483.83,334.07h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M486.21,331.98c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M469.2,348.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M473.96,349.92v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM472.75,348.49c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M474.51,351.81c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M476.58,351.14c-.26-.17-.46-.4-.6-.71s-.21-.66-.21-1.07.07-.75.21-1.06.34-.53.6-.7.57-.25.93-.25.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM478.41,350.54c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42-.32.67-.32,1.16.11.89.32,1.17.51.43.9.43.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M483.94,351.29h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M486.4,349.21c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.31,205.15c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.22,207.91c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M549.62,208.66c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M554.19,206.77v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM552.98,205.34c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M558.73,208.14h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M561.18,206.06c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.31,222.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.22,225.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M549.62,225.88c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M554.19,223.99v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM552.98,222.56c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M558.73,225.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M561.18,223.28c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.56,239.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.47,242.35c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M549.87,243.1c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M551.56,242.51c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M558.27,242.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M560.94,240.49c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.31,151.13c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.22,153.89c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M549.62,154.64c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M554.19,152.75v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM552.98,151.32c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M558.73,154.12h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M561.18,152.04c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.31,168.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.22,171.15c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M549.62,171.9c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M554.19,170.01v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM552.98,168.58c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M558.73,171.38h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M561.18,169.3c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.56,185.64c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.47,188.4c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M549.87,189.15c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M551.56,188.56c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M558.27,188.63h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M560.94,186.55c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.31,259.23c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.22,261.99c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M549.62,262.74c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M554.19,260.85v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM552.98,259.42c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M558.73,262.22h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M561.18,260.14c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.31,276.72c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.22,279.48c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M549.62,280.23c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M554.19,278.34v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM552.98,276.91c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M558.73,279.71h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M561.18,277.62c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.56,294.2c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.47,296.96c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M549.87,297.71c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M551.56,297.12c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M558.27,297.19h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M560.94,295.11c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.56,313.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.47,316.61c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M549.87,317.36c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M551.56,316.77c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M558.27,316.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M560.94,314.76c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.97,331.08c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.88,333.84c-.29-.22-.45-.51-.48-.88l.51-.06c.03.27.15.47.34.62s.46.22.8.22.6-.06.78-.19c.18-.13.26-.31.26-.55,0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.49c0-.2-.08-.36-.25-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.32Z"
                      />
                      <path
                        class="st1"
                        d="M550.28,334.59c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M552.23,331.08c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M557.83,334.07h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M560.53,331.98c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M544.56,348.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M546.47,351.06c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M549.87,351.81c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M551.56,351.22c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M558.27,351.29h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M560.94,349.21c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.03,205.15c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M583.94,207.91c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M587.33,208.66c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M591.41,204.72c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM590.9,206.09c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M596.53,208.14h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.95,206.06c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.03,222.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M583.94,225.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M587.33,225.88c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M591.41,221.94c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM590.9,223.31c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M596.53,225.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.95,223.28c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.12,239.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M586.88,241.21v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM585.67,239.78c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M587.43,243.1c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M588.86,242.15c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M596.66,242.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.86,240.49c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.03,151.13c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M583.94,153.89c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M587.33,154.64c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M591.41,150.7c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM590.9,152.07c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M596.53,154.12h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.95,152.04c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.12,168.39c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M586.88,170.01v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM585.67,168.58c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M587.43,171.9c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M588.86,170.95c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M596.66,171.38h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.86,169.3c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.03,185.64c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M583.94,188.4c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M587.33,189.15c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M591.41,185.21c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM590.9,186.58c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M596.53,188.63h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.95,186.55c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.03,259.23c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M583.94,261.99c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M587.33,262.74c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M591.41,258.8c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM590.9,260.17c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M596.53,262.22h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.95,260.14c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.03,276.72c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M583.94,279.48c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M587.33,280.23c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M591.41,276.29c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM590.9,277.66c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M596.53,279.71h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.95,277.62c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.12,294.2c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M586.88,295.82v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM585.67,294.39c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M587.43,297.71c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M588.86,296.76c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M596.66,297.19h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.86,295.11c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.12,313.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M586.88,315.47v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM585.67,314.04c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M587.43,317.36c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M588.86,316.41c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M596.66,316.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.86,314.76c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.03,331.08c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M583.94,333.84c-.29-.22-.45-.51-.48-.88l.51-.06c.03.27.14.47.33.62.19.15.46.22.8.22s.6-.06.78-.19c.18-.13.26-.31.26-.55,0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.49,0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.32Z"
                      />
                      <path
                        class="st1"
                        d="M587.33,334.59c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M591.39,331.84c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.39,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.37.49-.48s.48-.17.78-.17c.45,0,.8.12,1.05.35ZM590.99,333.48c.18-.17.27-.4.27-.68s-.09-.5-.26-.66-.42-.23-.74-.23c-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7.2.16.45.25.75.25s.54-.08.72-.26Z"
                      />
                      <path
                        class="st1"
                        d="M596.44,334.07h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2s-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.95,331.98c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M582.12,348.3c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M586.88,349.92v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM585.67,348.49c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M587.43,351.81c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M588.86,350.86c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M596.66,351.29h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M598.86,349.21c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.85,410.37c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M95.76,413.13c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M99.16,413.88c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M103.49,411.7c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM102.9,412.85c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM101.28,410.84c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M108.36,413.36h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.8,411.27c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <path
                  class="st1"
                  d="M125.69,417.23c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                />
                <path
                  class="st1"
                  d="M127.6,419.99c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28.37.43.37.75c0,.24-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.63-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                />
                <path
                  class="st1"
                  d="M131,420.74c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                />
                <path
                  class="st1"
                  d="M135.07,416.8c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51-.69.56-1.23.56c-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5h0ZM134.56,418.17c.21-.15.34-.34.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22h0Z"
                />
                <path
                  class="st1"
                  d="M130.23,426.22h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2s-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                />
                <path
                  class="st1"
                  d="M132.49,424.14c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c0-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.47-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24-.12.07-.26.14-.43.21h1.36v.27h-1.81v-.27h-.01Z"
                />
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.85,427.85c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M95.76,430.61c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M99.16,431.36c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M103.49,429.18c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39-.24.09-.53.14-.86.14-.52,0-.92-.1-1.22-.29-.3-.2-.44-.46-.44-.8,0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39ZM102.9,430.33c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.21-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.29-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19ZM101.28,428.32c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.6-.3.12-.11.18-.25.18-.43,0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16-.26.25-.26.45c0,.17.06.31.19.41Z"
                      />
                      <path
                        class="st1"
                        d="M108.36,430.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.8,428.76c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.73,445.34c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M98.49,446.96v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM97.28,445.53c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M99.04,448.85c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M101.11,448.18c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM102.94,447.58c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M108.47,448.33h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.92,446.24c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.93,465.43c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M98.69,467.05v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM97.48,465.62c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M99.24,468.94c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M101.11,468.23c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M108.37,468.42h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.72,466.34c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.93,483.56c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M98.69,485.18v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM97.48,483.75c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M99.24,487.07c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M101.11,486.36c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M108.37,486.55h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.72,484.47c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.88,504.51c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M98.64,506.13v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM97.43,504.7c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M99.19,508.02c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M103.26,504.08c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM102.75,505.45c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M108.39,507.5h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.77,505.41c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M93.88,523.68c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M98.64,525.3v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM97.43,523.87c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M99.19,527.19c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M103.26,523.25c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM102.75,524.62c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M108.39,526.67h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M110.77,524.59c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.19,410.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M248.95,412.21v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM247.74,410.78c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M249.5,414.1c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M251.37,413.39c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M258.63,413.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M260.98,411.5c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <path
                  class="st1"
                  d="M202.31,419.56c-.06.09-.17.16-.32.22-.15.06-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                />
                <path
                  class="st1"
                  d="M207.06,421.19v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM205.85,419.76v-.58h0c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                />
                <path
                  class="st1"
                  d="M207.62,423.07c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                />
                <path
                  class="st1"
                  d="M209.05,422.12c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22-.26.34-.26.59c0,.1,0,.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.33s.37.52.37.89c0,.27-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41-.21.12-.46.24-.74.36h2.33v.46h-3.11v-.43h.01Z"
                />
                <path
                  class="st1"
                  d="M206.87,428.56h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2s-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                />
                <path
                  class="st1"
                  d="M209.12,426.47c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c0-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.47-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24-.12.07-.26.14-.43.21h1.36v.27h-1.81v-.27h-.01Z"
                />
              </g>
              <g>
                <path
                  class="st1"
                  d="M220.12,419.56c-.06.09-.17.16-.32.22-.15.06-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                />
                <path
                  class="st1"
                  d="M224.87,421.19v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM223.66,419.76v-.58h0c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                />
                <path
                  class="st1"
                  d="M225.43,423.07c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                />
                <path
                  class="st1"
                  d="M226.86,422.12c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22-.26.34-.26.59c0,.1,0,.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.33s.37.52.37.89c0,.27-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41-.21.12-.46.24-.74.36h2.33v.46h-3.11v-.43h.01Z"
                />
                <path
                  class="st1"
                  d="M224.68,428.56h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2s-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                />
                <path
                  class="st1"
                  d="M226.93,426.47c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c0-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.47-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24-.12.07-.26.14-.43.21h1.36v.27h-1.81v-.27h-.01Z"
                />
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.19,428.54c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M248.95,430.16v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM247.74,428.73c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M249.5,432.05c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M251.37,431.34c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M258.63,431.53h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M260.98,429.45c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.19,449.04c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M248.95,450.66v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM247.74,449.23c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M249.5,452.55c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M251.37,451.84c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M258.63,452.03h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M260.98,449.95c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.19,466.81c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M248.95,468.43v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM247.74,467c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M249.5,470.32c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M251.37,469.61c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M258.63,469.8h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M260.98,467.71c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M207.45,449.04c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M212.21,450.66v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM211,449.23c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M212.76,452.55c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M214.63,451.84c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M221.89,452.03h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M224.25,449.95c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M207.45,466.81c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M212.21,468.43v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM211,467c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M212.76,470.32c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M214.63,469.61c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M221.89,469.8h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M224.25,467.71c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.19,486.93c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M248.95,488.55v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM247.74,487.12c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M249.5,490.44c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M251.37,489.73c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M258.63,489.92h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M260.98,487.84c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.19,504.83c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M248.95,506.45v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM247.74,505.02c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M249.5,508.34c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M251.37,507.63c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53s.41.19.69.19c.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.16s-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.14.72-.14.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M258.63,507.82h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M260.98,505.74c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M244.19,522.74c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M248.95,524.36v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM247.74,522.93c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M249.5,526.25c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M251.37,525.54c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M258.63,525.73h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M260.98,523.64c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.14,410.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.9,412.21v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.69,410.78c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.45,414.1c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M325.32,413.39c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M332.58,413.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.93,411.5c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.16,428.54c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.92,430.16v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.71,428.73c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.47,432.05c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M324.9,431.1c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st1"
                        d="M332.7,431.53h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.9,429.45c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.14,449.04c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.9,450.66v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.69,449.23c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.45,452.55c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M325.32,451.84c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M332.58,452.03h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.93,449.95c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.14,466.81c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.9,468.43v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.69,467c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.45,470.32c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M325.32,469.61c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M332.58,469.8h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.93,467.71c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.14,486.93c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.9,488.55v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.69,487.12c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.45,490.44c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M325.32,489.73c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M332.58,489.92h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.93,487.84c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.14,504.83c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.9,506.45v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.69,505.02c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.45,508.34c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M325.32,507.63c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53s.41.19.69.19c.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.16s-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.14.72-.14.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M332.58,507.82h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.93,505.74c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M318.14,522.74c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M322.9,524.36v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM321.69,522.93c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M323.45,526.25c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M325.32,525.54c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73s-.31.37-.55.49-.51.17-.83.17c-.41,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M332.58,525.73h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M334.93,523.64c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.3,410.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.21,413.35c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M361.6,414.1c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M365.68,410.16c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM365.17,411.53c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M370.8,413.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M373.23,411.5c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.58,428.54c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.49,431.3c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M361.89,432.05c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M363.58,431.46c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M370.29,431.53h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M372.96,429.45c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.3,449.04c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.21,451.8c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M361.6,452.55c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M365.68,448.61c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM365.17,449.98c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M370.8,452.03h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M373.23,449.95c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.3,466.81c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M358.21,469.57c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st1"
                        d="M361.6,470.32c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M365.68,466.38c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44s-.47.16-.76.16c-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45.5-.16.81-.16c.54,0,.96.17,1.24.5ZM365.17,467.75c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23c-.18.15-.27.36-.27.62s.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M370.8,469.8h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M373.23,467.71c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.17,486.93c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M360.93,488.55v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM359.72,487.12c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M361.48,490.44c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M363.55,489.77c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM365.38,489.17c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M370.91,489.92h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M373.36,487.84c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.17,504.83c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M360.93,506.45v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM359.72,505.02c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M361.48,508.34c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M363.55,507.67c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.05c.14-.3.34-.54.6-.7.26-.17.57-.25.93-.25s.67.08.93.25c.26.17.46.4.6.7.14.3.21.65.21,1.05s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM365.38,507.07c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.29-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M370.91,507.82h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M373.36,505.74c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M356.17,522.74c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M360.93,524.36v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM359.72,522.93c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M361.48,526.25c.14-.05.23-.11.28-.19s.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M363.55,525.58c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71s-.57.25-.93.25-.67-.08-.93-.25ZM365.38,524.98c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16c-.21-.28-.51-.43-.9-.43s-.69.14-.9.42c-.21.28-.32.67-.32,1.16s.11.89.32,1.17c.21.29.51.43.9.43s.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M370.91,525.73h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M373.36,523.64c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M432.05,410.59c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M436.81,412.21v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM435.6,410.78c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M437.36,414.1c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M439.05,413.51c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M445.76,413.58h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.4,411.5c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M507.16,407.88c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M509.16,410.68c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53.18.13.41.19.69.19.33,0,.58-.08.76-.25.18-.17.27-.4.27-.69s-.09-.53-.26-.7c-.17-.17-.42-.25-.73-.25-.26,0-.47.05-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42.2-.1.44-.15.72-.15.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.42,0-.76-.1-1.03-.29Z"
                      />
                      <path
                        class="st1"
                        d="M512.37,411.39c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M514.06,410.8c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M520.77,410.87h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M523.46,408.79c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M561.21,407.88c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M563.31,410.8c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.53.47-.93.99-1.21,1.55-.29.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M565.51,411.39c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M567.58,410.72c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7s.57-.25.93-.25.67.08.93.25.46.4.6.7.21.65.21,1.06-.07.76-.21,1.07-.34.54-.6.71-.57.25-.93.25-.67-.08-.93-.25ZM569.41,410.12c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16-.51-.43-.9-.43-.69.14-.9.42-.32.67-.32,1.16.11.89.32,1.17.51.43.9.43.69-.14.9-.43Z"
                      />
                      <path
                        class="st1"
                        d="M574.94,410.87h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M577.92,408.79c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.81,428.54c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M436.57,430.16v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM435.36,428.73c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M437.12,432.05c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M441.69,430.16v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM440.48,428.73c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M446.23,431.53h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.64,429.45c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25c.13-.06.29-.09.46-.09.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M432.05,449.04c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M436.81,450.66v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM435.6,449.23c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M437.36,452.55c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M439.05,451.96c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M445.76,452.03h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.4,449.95c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M432.05,466.81c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M436.81,468.43v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM435.6,467c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M437.36,470.32c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M439.05,469.73c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M445.76,469.8h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.4,467.71c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M432.05,486.93c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M436.81,488.55v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM435.6,487.12c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M437.36,490.44c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M439.05,489.85c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M445.76,489.92h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.4,487.84c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M432.05,504.83c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.43v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M436.81,506.45v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM435.6,505.02c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M437.36,508.34c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M439.05,507.75c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.98-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                      />
                      <path
                        class="st1"
                        d="M445.76,507.82h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12c0-.04,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.4,505.74c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M431.78,522.74c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.44v3.82h-.51v-2.99Z"
                      />
                      <path
                        class="st1"
                        d="M436.54,524.36v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73ZM435.33,522.93c0-.27,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43Z"
                      />
                      <path
                        class="st1"
                        d="M437.09,526.25c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                      />
                      <path
                        class="st1"
                        d="M441.16,522.31c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.41,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.86-.43s.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5ZM440.65,523.68c.21-.15.34-.33.39-.57-.06-.27-.18-.48-.36-.64-.18-.16-.43-.24-.75-.24s-.56.08-.75.23-.28.36-.28.62.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22Z"
                      />
                      <path
                        class="st1"
                        d="M446.29,525.73h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st1"
                        d="M448.67,523.64c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <g>
                  <path
                    class="st1"
                    d="M623.15,138.98c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M627.46,139.74c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51.71-.53,1.25-.53c.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35h-.02,0ZM627.05,141.39c.18-.17.27-.4.27-.68s-.09-.5-.26-.66-.42-.23-.74-.23c-.3,0-.55.08-.75.23s-.33.37-.39.65c.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26h.01Z"
                  />
                  <path
                    class="st1"
                    d="M628.48,142.49c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M633.05,140.6v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM631.84,139.17c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M627.66,147.97h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M629.92,145.89c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M643.2,132.76c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M645.11,135.52c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28.37.43.37.75c0,.23-.08.43-.23.58-.15.15-.35.25-.59.29.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M648.51,136.27c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M652.58,132.33c.28.33.43.81.43,1.43s-.14,1.14-.42,1.52c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.85-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32s-.39-.52-.39-.92c0-.25.06-.46.19-.66.13-.19.31-.34.54-.45s.5-.16.81-.16c.54,0,.96.17,1.24.5h0ZM652.07,133.7c.21-.15.34-.34.39-.57-.06-.27-.18-.48-.36-.64s-.43-.24-.75-.24-.56.08-.75.23-.28.36-.28.62.09.47.27.61.42.21.73.21c.29,0,.54-.07.75-.22h0Z"
                  />
                  <path
                    class="st1"
                    d="M647.74,141.75h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M650,139.67c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M661.72,126.89c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M663.63,129.65c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28.37.43.37.75c0,.23-.08.43-.23.58-.15.15-.35.25-.59.29.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M667.03,130.4c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M668.81,129.65c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28.37.43.37.75c0,.23-.08.43-.23.58-.15.15-.35.25-.59.29.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M666.26,135.89h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M668.52,133.8c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M678.15,121.32c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M680.06,124.09c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28.37.43.37.75c0,.23-.08.43-.23.58-.15.15-.35.25-.59.29.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M683.46,124.83c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M688.03,122.95v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM686.82,121.52c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M682.65,130.32h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M684.91,128.23c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M694.89,115.76c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M696.8,118.52c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28.37.43.37.75c0,.23-.08.43-.23.58-.15.15-.35.25-.59.29.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M700.2,119.27c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M701.89,118.68c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.6h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07h0Z"
                  />
                  <path
                    class="st1"
                    d="M699.04,124.75h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M701.29,122.66c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M713.63,108c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M717.93,108.77c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51.71-.53,1.25-.53c.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35h-.02,0ZM717.53,110.41c.18-.17.27-.4.27-.68s-.09-.5-.26-.66-.42-.23-.74-.23c-.3,0-.55.08-.75.23s-.33.37-.39.65c.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26c0,0,.01,0,.01,0Z"
                  />
                  <path
                    class="st1"
                    d="M718.95,111.51c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M720.82,110.8c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53s.41.19.69.19c.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.06-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42s.44-.15.72-.15c.43,0,.76.12,1,.35.24.24.36.57.36,1,0,.27-.06.52-.19.73-.13.21-.31.37-.55.49-.24.11-.51.17-.83.17-.41,0-.76-.1-1.03-.29h.01Z"
                  />
                  <path
                    class="st1"
                    d="M718.14,117h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M720.4,114.91c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M731.58,101.98c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M735.88,102.74c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51.71-.53,1.25-.53c.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35h-.02,0ZM735.48,104.38c.18-.17.27-.4.27-.68s-.09-.5-.26-.66-.42-.23-.74-.23c-.3,0-.55.08-.75.23s-.33.37-.39.65c.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26c0,0,.01,0,.01,0Z"
                  />
                  <path
                    class="st1"
                    d="M736.9,105.48c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M738.33,104.53c.72-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22-.26.34-.26.59c0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.27-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.45h0Z"
                  />
                  <path
                    class="st1"
                    d="M736.14,110.97h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M738.4,108.88c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M749.59,95.95c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M753.89,96.71c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51-.29-.34-.44-.83-.44-1.46s.15-1.15.44-1.51.71-.53,1.25-.53c.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35h-.02,0ZM753.49,98.35c.18-.17.27-.4.27-.68s-.09-.5-.26-.66-.42-.23-.74-.23c-.3,0-.55.08-.75.23s-.33.37-.39.65c.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26c0,0,.01,0,.01,0Z"
                  />
                  <path
                    class="st1"
                    d="M754.91,99.46c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M759.25,97.28c.15.16.22.37.22.62,0,.23-.07.43-.2.6s-.32.3-.56.39-.53.14-.86.14c-.52,0-.92-.1-1.22-.29s-.44-.46-.44-.8c0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39,0,0,.01,0,.01,0ZM758.66,98.43c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45s-.37-.2-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.3-.21.5,0,.23.1.41.3.54s.48.2.84.2.61-.06.81-.19h.01ZM757.03,96.42c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3s.18-.25.18-.43c0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41h.01Z"
                  />
                  <path
                    class="st1"
                    d="M754.14,104.94h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M756.4,102.86c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M657.53,241.3c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M659.63,244.23c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.6h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55s-.43,1.15-.43,1.77v.11h-.58v-.07h0Z"
                  />
                  <path
                    class="st1"
                    d="M661.83,244.81c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M663.26,243.86c.72-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22-.26.34-.26.59c0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.27-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41-.21.12-.46.24-.74.36h2.33v.46h-3.11v-.45h0Z"
                  />
                  <path
                    class="st1"
                    d="M661.58,250.3h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M663.84,248.21c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M684.6,186.27c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M688.83,185.84c.28.33.43.81.43,1.43s-.14,1.14-.42,1.52c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.85-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32s-.39-.52-.39-.92c0-.25.06-.46.19-.66.13-.19.31-.34.54-.45s.5-.16.81-.16c.54,0,.96.17,1.24.5h0ZM688.32,187.21c.21-.15.34-.34.39-.57-.06-.27-.18-.48-.36-.64s-.43-.24-.75-.24-.56.08-.75.23-.28.36-.28.62.09.47.27.61.42.21.73.21c.29,0,.54-.07.75-.22h0Z"
                  />
                  <path
                    class="st1"
                    d="M689.9,189.78c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M694.24,187.59c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29s-.44-.46-.44-.8c0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39h.01ZM693.65,188.75c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45s-.37-.2-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.3-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19h.01ZM692.02,186.74c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3s.18-.25.18-.43c0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41h.01Z"
                  />
                  <path
                    class="st1"
                    d="M689.14,195.26h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M691.4,193.17c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M740.6,177.37c-.06.09-.17.16-.32.22s-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M745.35,179v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM744.14,177.57c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M745.91,180.88c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M747.6,180.3c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.6h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55s-.43,1.15-.43,1.77v.11h-.58v-.07h0Z"
                  />
                  <path
                    class="st1"
                    d="M744.74,186.37h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M747,184.28c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M756.58,171.73c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M761.34,173.35v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM760.13,171.92c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M761.9,175.24c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M763.33,174.28c.72-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22-.26.34-.26.59c0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.27-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41-.21.12-.46.24-.74.36h2.33v.46h-3.11v-.45h0Z"
                  />
                  <path
                    class="st1"
                    d="M761.14,180.72h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M763.4,178.63c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M772.98,166.08c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M777.74,167.7v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM776.53,166.27c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M778.29,169.59c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M779.72,168.64c.72-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22-.26.34-.26.59c0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.27-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41-.21.12-.46.24-.74.36h2.33v.46h-3.11v-.45h0Z"
                  />
                  <path
                    class="st1"
                    d="M777.54,175.07h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M779.8,172.99c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M751.95,211c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M753.86,213.76c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28.37.43.37.75c0,.23-.08.43-.23.58-.15.15-.35.25-.59.29.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M757.26,214.51c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M761.59,212.33c.15.16.22.37.22.62,0,.23-.07.43-.2.6-.13.17-.32.3-.56.39s-.53.14-.86.14c-.52,0-.92-.1-1.22-.29s-.44-.46-.44-.8c0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12.4.2.52.34.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39h.01ZM761,213.49c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45s-.37-.2-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.3-.21.5,0,.23.1.41.3.54.2.13.48.2.84.2s.61-.06.81-.19h.01ZM759.38,211.48c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3s.18-.25.18-.43c0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41h.01Z"
                  />
                  <path
                    class="st1"
                    d="M756.5,219.99h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M758.75,217.91c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M768.35,205.36c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M770.26,208.12c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28.37.43.37.75c0,.23-.08.43-.23.58-.15.15-.35.25-.59.29.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M773.66,208.86c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M775.44,208.12c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28.37.43.37.75c0,.23-.08.43-.23.58-.15.15-.35.25-.59.29.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M772.89,214.35h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M775.15,212.26c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M784.75,199.71c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M786.66,202.47c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28.37.43.37.75c0,.23-.08.43-.23.58-.15.15-.35.25-.59.29.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M790.06,203.22c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M791.84,202.47c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47s-.4-.17-.72-.17-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28.37.43.37.75c0,.23-.08.43-.23.58-.15.15-.35.25-.59.29.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M789.29,208.7h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M791.55,206.62c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M762.96,244.76c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M767.72,246.39v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM766.51,244.96c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M768.28,248.27c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M772.85,246.39v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM771.64,244.96c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M767.46,253.76h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M769.72,251.67c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M742.05,250.88c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M746.36,251.65c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51.71-.53,1.25-.53c.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35h-.02,0ZM745.95,253.29c.18-.17.27-.4.27-.68s-.09-.5-.26-.66-.42-.23-.74-.23c-.3,0-.55.08-.75.23s-.33.37-.39.65c.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26h.01Z"
                  />
                  <path
                    class="st1"
                    d="M747.37,254.39c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M751.43,251.65c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51.71-.53,1.25-.53c.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4-.2.27-.3.65-.3,1.16.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35h-.02,0ZM751.03,253.29c.18-.17.27-.4.27-.68s-.09-.5-.26-.66-.42-.23-.74-.23c-.3,0-.55.08-.75.23s-.33.37-.39.65c.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26h.01Z"
                  />
                  <path
                    class="st1"
                    d="M746.55,259.88h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M748.81,257.79c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M721.53,256.9c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M726.29,258.52v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM725.08,257.09c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M726.84,260.41c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M728.27,259.45c.72-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22-.26.34-.26.59c0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.27-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.45h0Z"
                  />
                  <path
                    class="st1"
                    d="M726.09,265.89h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M728.34,263.8c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M705.51,262.58c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M707.42,265.34c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28.37.43.37.75c0,.23-.08.43-.23.58-.15.15-.35.25-.59.29.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M710.82,266.09c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M714.89,262.15c.28.33.43.81.43,1.43s-.14,1.14-.42,1.52c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.85-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66.13-.19.31-.34.54-.45.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5h0ZM714.38,263.52c.21-.15.34-.34.39-.57-.06-.27-.18-.48-.36-.64s-.43-.24-.75-.24-.56.08-.75.23-.28.36-.28.62.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22h0Z"
                  />
                  <path
                    class="st1"
                    d="M710.05,271.57h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M712.31,269.48c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M689.45,268.26c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M694.21,269.88v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM693,268.45c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M694.77,271.77c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M696.2,270.81c.72-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22-.26.34-.26.59c0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.27-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.45h0Z"
                  />
                  <path
                    class="st1"
                    d="M694.01,277.25h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M696.27,275.16c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M670.16,274.57c-.06.09-.17.16-.32.22s-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M672.07,277.33c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19c.18-.13.26-.31.26-.55,0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28c.25.18.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M675.47,278.08c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M679.81,275.9c.15.16.22.37.22.62,0,.23-.07.43-.2.6s-.32.3-.56.39-.53.14-.86.14c-.52,0-.92-.1-1.22-.29s-.44-.46-.44-.8c0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39h.01ZM679.22,277.06c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.2-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.3-.21.5,0,.23.1.41.3.54s.48.2.84.2.61-.06.81-.19h.01ZM677.59,275.05c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3s.18-.25.18-.43c0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41h.01Z"
                  />
                  <path
                    class="st1"
                    d="M674.71,283.56h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M676.97,281.48c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M653.9,279.91c-.06.09-.17.16-.32.22s-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M655.81,282.68c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19c.18-.13.26-.31.26-.55,0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28c.25.18.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M659.21,283.42c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M663.54,281.24c.15.16.22.37.22.62,0,.23-.07.43-.2.6s-.32.3-.56.39-.53.14-.86.14c-.52,0-.92-.1-1.22-.29s-.44-.46-.44-.8c0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39h.01ZM662.95,282.4c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.2-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.3-.21.5,0,.23.1.41.3.54s.48.2.84.2.61-.06.81-.19h.01ZM661.33,280.39c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3s.18-.25.18-.43c0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41h.01Z"
                  />
                  <path
                    class="st1"
                    d="M658.45,288.91h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M660.7,286.82c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M779.17,239.31c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M783.92,240.93v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM782.71,239.5c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M784.48,242.82c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M785.91,241.86c.72-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22-.26.34-.26.59c0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.27-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41-.21.12-.46.24-.74.36h2.33v.46h-3.11v-.45h0Z"
                  />
                  <path
                    class="st1"
                    d="M783.73,248.3h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M785.98,246.21c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M795.43,233.85c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M800.19,235.47v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM798.98,234.04c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21-.04.06-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M800.74,237.36c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M802.17,236.41c.72-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.4-.22-.71-.22s-.53.07-.7.22-.26.34-.26.59c0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.27-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41-.21.12-.46.24-.74.36h2.33v.46h-3.11v-.45h0Z"
                  />
                  <path
                    class="st1"
                    d="M799.99,242.84h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M802.25,240.76c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24s-.27.14-.43.21h1.36v.27h-1.81v-.27h0Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M786.77,314.93c-.06.09-.17.16-.32.22s-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M791.52,316.55v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM790.31,315.12c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M792.07,318.44c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M794.14,317.78c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.76.21-1.06.34-.53.6-.7c.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM795.97,317.17c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16-.51-.43-.9-.43-.69.14-.9.42-.32.67-.32,1.16.11.88.32,1.17.51.43.9.43.69-.14.9-.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M791.42,323.92h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M793.68,321.84c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M803.29,308.96c-.06.09-.17.16-.32.22s-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M805.19,311.72c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19c.18-.13.26-.31.26-.55,0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28c.25.18.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M808.58,312.47c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M812.91,310.29c.15.16.22.37.22.62,0,.23-.07.43-.2.6s-.32.3-.56.39-.53.14-.86.14c-.52,0-.92-.1-1.22-.29s-.44-.46-.44-.8c0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39h.01ZM812.32,311.44c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.2-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.3-.21.5,0,.23.1.41.3.54s.48.2.84.2.61-.06.81-.19h.01ZM810.7,309.43c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3s.18-.25.18-.43c0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41h.01Z"
                  />
                  <path
                    class="st1"
                    d="M807.82,317.95h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M810.08,315.87c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M819.57,303.64c-.06.09-.17.16-.32.22s-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M824.32,305.26v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM823.11,303.83c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M824.87,307.15c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M826.93,306.48c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.76.21-1.06.34-.53.6-.7c.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM828.76,305.88c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16-.51-.43-.9-.43-.69.14-.9.42-.32.67-.32,1.16.11.88.32,1.17.51.43.9.43.69-.14.9-.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M824.22,312.63h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M826.48,310.54c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M797.21,347.25c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M801.97,348.87v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM800.76,347.44c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M802.52,350.75c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M804.58,350.09c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.75.21-1.06c.14-.3.34-.53.6-.7.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7.21.65.21,1.06-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM806.41,349.49c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16-.51-.43-.9-.43-.69.14-.9.42-.32.67-.32,1.16.11.89.32,1.17.51.43.9.43.69-.14.9-.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M801.87,356.24h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2s-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M804.12,354.15c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M777.15,353.95c-.06.09-.17.16-.32.22s-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.29-.29.35-.5h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M781.45,354.71c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.12.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.47.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4s-.3.65-.3,1.16c.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35h0ZM781.05,356.35c.18-.17.27-.4.27-.68s-.09-.5-.26-.66-.42-.23-.74-.23c-.3,0-.54.08-.74.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26Z"
                  />
                  <path
                    class="st1"
                    d="M782.46,357.46c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M787.03,355.57v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM785.82,354.14c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M781.65,362.94h-.46l-1-1.94c-.03-.07-.06-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M783.91,360.85c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.09-.21.09-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13c-.17,0-.31.04-.41.13-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2s.22.3.22.52c0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27h-.01Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M766.07,321.45c-.06.09-.17.16-.32.22s-.31.09-.49.09h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.49h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M768.06,324.25c-.27-.19-.45-.45-.52-.79l.53-.08c.05.22.17.4.35.53s.41.19.69.19c.33,0,.58-.08.76-.25s.27-.4.27-.69-.09-.53-.26-.7-.42-.25-.73-.25c-.26,0-.47.06-.64.17-.17.11-.29.28-.38.5l-.5-.04.25-2.22h2.57v.44h-2.18l-.16,1.3c.11-.18.26-.32.46-.42s.44-.15.72-.15c.43,0,.76.12,1,.35s.36.57.36,1c0,.28-.06.52-.19.73-.13.21-.31.37-.55.49s-.51.17-.83.17c-.41,0-.76-.09-1.03-.29h.01Z"
                  />
                  <path
                    class="st1"
                    d="M771.26,324.96c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M775.33,321.02c.28.33.43.81.43,1.43s-.14,1.14-.42,1.51c-.28.38-.69.56-1.23.56-.42,0-.75-.09-1.02-.28-.26-.19-.43-.45-.49-.78l.51-.12c.06.25.17.44.33.57.16.12.38.19.67.19.38,0,.67-.14.85-.43.19-.29.28-.69.28-1.21v-.04c-.11.19-.27.33-.48.44-.21.11-.47.16-.76.16-.44,0-.8-.11-1.06-.32-.26-.21-.39-.52-.39-.92,0-.25.06-.46.19-.66s.31-.34.54-.45c.23-.11.5-.16.81-.16.54,0,.96.17,1.24.5h0ZM774.82,322.39c.21-.15.34-.34.39-.57-.06-.27-.18-.48-.36-.64s-.43-.24-.75-.24-.56.08-.75.23-.28.36-.28.62.09.47.27.61c.18.14.42.21.73.21.29,0,.54-.07.75-.22h0Z"
                  />
                  <path
                    class="st1"
                    d="M770.55,330.44h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2s-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M772.8,328.35c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33s.08-.21.08-.34c0-.14-.05-.25-.14-.34-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M730.14,323.33c-.06.09-.17.16-.32.22s-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M734.44,324.09c.25.23.38.55.38.97,0,.26-.06.5-.19.7-.13.21-.3.37-.53.48-.23.12-.49.17-.78.17-.54,0-.96-.17-1.25-.51s-.44-.83-.44-1.46.15-1.15.44-1.51c.29-.36.71-.53,1.25-.53.4,0,.72.09.98.26.26.18.42.42.48.74l-.51.12c-.12-.46-.44-.69-.95-.69-.38,0-.68.13-.88.4s-.3.65-.3,1.16c.11-.21.27-.36.49-.48.22-.11.48-.17.78-.17.45,0,.8.12,1.05.35h-.02,0ZM734.04,325.74c.18-.17.27-.4.27-.68s-.09-.5-.26-.66-.42-.23-.74-.23c-.3,0-.55.08-.75.23-.2.15-.33.37-.39.65.06.3.19.53.39.7s.45.25.75.25.54-.08.72-.26h.01Z"
                  />
                  <path
                    class="st1"
                    d="M735.45,326.84c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M739.78,324.66c.15.16.22.37.22.62,0,.23-.07.43-.2.6s-.32.3-.56.39-.53.14-.86.14c-.52,0-.92-.1-1.22-.29s-.44-.46-.44-.8c0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39h.01ZM739.19,325.82c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.2-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.3-.21.5,0,.23.1.41.3.54s.48.2.84.2.61-.06.81-.19h.01ZM737.57,323.81c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3s.18-.25.18-.43c0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41h.01Z"
                  />
                  <path
                    class="st1"
                    d="M734.68,332.32h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M736.94,330.24c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M813.73,341.27c-.06.09-.17.16-.32.22s-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M815.63,344.03c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62s.46.22.8.22.6-.06.78-.19c.18-.13.26-.31.26-.55,0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88s.64-.33,1.11-.33.83.09,1.08.28c.25.18.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29s.25.37.25.65c0,.35-.13.64-.4.85s-.66.32-1.17.32c-.48,0-.86-.11-1.15-.32h0Z"
                  />
                  <path
                    class="st1"
                    d="M819.02,344.78c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M823.35,342.6c.15.16.22.37.22.62,0,.23-.07.43-.2.6s-.32.3-.56.39-.53.14-.86.14c-.52,0-.92-.1-1.22-.29s-.44-.46-.44-.8c0-.26.08-.47.23-.64.16-.17.38-.29.68-.36-.27-.09-.46-.21-.59-.36-.12-.15-.19-.34-.19-.56,0-.2.06-.37.19-.52.12-.15.3-.27.53-.35.23-.08.49-.12.8-.12s.56.04.78.12c.22.08.4.2.52.34s.18.32.18.52c0,.22-.07.41-.2.56s-.33.26-.58.32c.32.1.56.23.7.39h.01ZM822.76,343.76c.19-.13.29-.3.29-.53,0-.19-.07-.34-.21-.45-.14-.11-.37-.2-.69-.28l-.45-.1c-.32.08-.55.19-.69.31-.14.13-.21.3-.21.5,0,.23.1.41.3.54s.48.2.84.2.61-.06.81-.19h.01ZM821.14,341.75c.13.11.33.19.61.25l.38.08c.29-.09.49-.19.61-.3s.18-.25.18-.43c0-.2-.09-.35-.26-.46s-.41-.16-.73-.16-.55.05-.73.16c-.17.11-.26.25-.26.45,0,.17.06.31.19.41h.01Z"
                  />
                  <path
                    class="st1"
                    d="M818.26,350.26h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M820.52,348.18c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M830.01,335.95c-.06.09-.17.16-.32.22s-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18s.28-.29.35-.5h.43v3.82h-.51v-2.99h0Z"
                  />
                  <path
                    class="st1"
                    d="M834.76,337.57v.4h-.73v.97h-.48v-.97h-2.23v-.35l2.12-2.5h.59v2.45h.73,0ZM833.55,336.14c0-.28,0-.47.01-.58h-.01c-.03.08-.07.15-.11.21s-.11.15-.2.25l-.95,1.1c-.17.2-.3.35-.4.45h1.66v-1.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M835.31,339.46c.14-.05.23-.12.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54s-.22.23-.43.3l-.13-.26h0Z"
                  />
                  <path
                    class="st1"
                    d="M837.37,338.8c-.26-.17-.46-.4-.6-.71-.14-.3-.21-.66-.21-1.07s.07-.76.21-1.06.34-.53.6-.7c.26-.17.57-.25.93-.25s.67.08.93.25.46.4.6.7c.14.3.21.65.21,1.06s-.07.76-.21,1.07c-.14.3-.34.54-.6.71-.26.17-.57.25-.93.25s-.67-.08-.93-.25ZM839.21,338.19c.21-.29.32-.68.32-1.17s-.11-.87-.32-1.16-.51-.43-.9-.43-.69.14-.9.42-.32.67-.32,1.16.11.88.32,1.17.51.43.9.43.69-.14.9-.43h0Z"
                  />
                  <path
                    class="st1"
                    d="M834.66,344.94h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.37h-.02c-.04.11-.11.26-.19.43l-.99,1.94h.01Z"
                  />
                  <path
                    class="st1"
                    d="M836.92,342.86c.42-.18.77-.4,1.07-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.34s-.23-.13-.41-.13-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.2.15.13.22.3.22.52,0,.16-.04.31-.13.45s-.22.27-.39.41c-.12.09-.24.17-.36.24-.12.07-.27.14-.43.21h1.36v.27h-1.81v-.27Z"
                  />
                </g>
              </g>
            </g>
            <g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M612.18,160.53c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.39-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M616.24,160.73c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.25-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23c-.17.16-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M619.97,160.73c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.34.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.68-.17s.24-.28.24-.5c0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M611.98,166.26c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.39-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st1"
                          d="M615.87,167.21c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M617.56,166.62c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                        />
                        <path
                          class="st1"
                          d="M624.27,166.69h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M626.83,164.61c.42-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13-.15.2-.15.34c0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36s.17-.19.3-.25.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M646.67,200.84c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M650.73,201.04c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.14.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.32v-.41h.31c.3,0,.53-.06.68-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.08.43-.23.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M653.96,200.84c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.39-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M644.38,207.22c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43.49-.15.8-.15c.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76-.15.23-.38.47-.67.7-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st1"
                          d="M648.27,208.17c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M649.96,207.58c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                        />
                        <path
                          class="st1"
                          d="M656.67,207.65h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M659.23,205.57c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g class="st2">
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <path
                        class="st0"
                        d="M684.72,330.57c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58s-.4-.22-.71-.22-.53.07-.71.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62s.29-.32.52-.43c.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34s.37.52.37.89c0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                      />
                      <path
                        class="st0"
                        d="M688.78,330.77c-.29-.22-.45-.51-.48-.88l.51-.07c.03.27.15.48.33.62.19.15.46.22.8.22s.6-.06.78-.19.26-.31.26-.55c0-.47-.35-.7-1.04-.7h-.33v-.41h.31c.3,0,.53-.06.69-.17.16-.11.24-.28.24-.5,0-.2-.08-.36-.24-.47-.16-.11-.4-.17-.72-.17s-.58.08-.75.23-.27.37-.28.65l-.48-.1c.02-.37.16-.66.43-.88.27-.22.64-.33,1.11-.33s.83.09,1.08.28c.25.19.37.43.37.75,0,.23-.07.43-.22.58s-.35.25-.59.29c.3.04.53.14.7.29.17.15.25.37.25.65,0,.35-.13.64-.4.85-.27.21-.66.32-1.17.32-.48,0-.86-.11-1.15-.33Z"
                      />
                      <path
                        class="st0"
                        d="M692.99,328.01c-.06.09-.17.16-.32.22-.15.06-.31.08-.49.08h-.19v-.46h.12c.24,0,.44-.06.61-.18.17-.12.28-.29.35-.5h.44v3.82h-.51v-2.99Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M681.07,336.6c.71-.32,1.33-.68,1.83-1.1.25-.21.42-.39.51-.57.1-.17.15-.37.15-.58,0-.24-.08-.43-.24-.58-.16-.15-.39-.22-.71-.22s-.53.07-.7.22c-.17.15-.26.34-.26.59,0,.1.01.21.04.31l-.52-.05c-.02-.1-.03-.19-.03-.29,0-.23.06-.44.18-.62.12-.18.29-.32.52-.43.23-.1.49-.15.8-.15.48,0,.84.11,1.09.34.25.22.37.52.37.89,0,.28-.08.53-.23.76s-.38.47-.67.7c-.2.15-.41.29-.62.41s-.46.24-.74.36h2.33v.46h-3.11v-.43Z"
                        />
                        <path
                          class="st1"
                          d="M684.96,337.55c.14-.05.23-.11.28-.19.05-.08.08-.18.08-.31v-.02h-.38v-.68h.7v.61c0,.23-.04.41-.12.54-.08.13-.22.23-.43.3l-.13-.26Z"
                        />
                        <path
                          class="st1"
                          d="M686.65,336.96c0-.58.14-1.15.42-1.71.28-.56.67-1.09,1.19-1.59h-2.38v-.46h3v.4c-.52.47-.93.99-1.21,1.55-.28.56-.43,1.15-.43,1.77v.11h-.58v-.07Z"
                        />
                        <path
                          class="st1"
                          d="M693.36,337.03h-.46l-1-1.94c-.03-.07-.07-.13-.1-.2-.03-.07-.06-.15-.09-.23h-.02v2.37h-.45v-2.75h.75l.99,1.97c.07.15.11.26.14.34h.02c.03-.08.07-.2.14-.34l.99-1.97h.74v2.75h-.46v-2.11s0-.08,0-.12,0-.09,0-.14h-.02c-.04.11-.11.26-.19.43l-.99,1.94Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g class="st2">
                  <g class="st2">
                    <g class="st2">
                      <g class="st2">
                        <path
                          class="st1"
                          d="M695.91,334.95c.41-.18.77-.4,1.06-.64.14-.12.24-.23.3-.33.06-.1.08-.21.08-.34,0-.14-.05-.25-.14-.33-.09-.08-.23-.13-.41-.13s-.31.04-.41.13c-.1.08-.15.2-.15.34,0,.06,0,.12.02.18l-.3-.03c-.01-.06-.02-.11-.02-.17,0-.14.04-.26.11-.36.07-.11.17-.19.3-.25s.29-.09.46-.09c.28,0,.49.07.63.19.14.13.22.3.22.52,0,.16-.04.31-.13.44-.09.14-.22.27-.39.41-.12.09-.24.17-.36.24s-.26.14-.43.21h1.35v.26h-1.8v-.25Z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <rect
            id="p34"
            class="st8"
            x="617.92"
            y="121.7"
            width="18.83"
            height="35.81"
            transform="translate(-11.97 205.38) rotate(-18.42)"
          />
          <rect
            id="p33"
            class="st8"
            x="638.3"
            y="115.11"
            width="17.69"
            height="35.81"
            transform="translate(-8.87 211.3) rotate(-18.42)"
          />
          <rect
            id="p32"
            class="st8"
            x="657.34"
            y="108.86"
            width="17.15"
            height="35.81"
            transform="translate(-5.94 216.91) rotate(-18.42)"
          />
          <rect
            id="p31"
            class="st8"
            x="673.6"
            y="103.44"
            width="17.15"
            height="35.81"
            transform="translate(-3.39 221.77) rotate(-18.42)"
          />
          <rect
            id="p30"
            class="st8"
            x="689.87"
            y="98.01"
            width="17.15"
            height="35.81"
            transform="translate(-.84 226.63) rotate(-18.42)"
          />
          <rect
            id="p29"
            class="st8"
            x="707.91"
            y="88.21"
            width="19.12"
            height="39.13"
            transform="translate(2.7 232.23) rotate(-18.42)"
          />
          <rect
            id="p28"
            class="st8"
            x="726.04"
            y="82.19"
            width="19.12"
            height="39.13"
            transform="translate(5.53 237.65) rotate(-18.42)"
          />
          <rect
            id="p27"
            class="st8"
            x="744.17"
            y="76.13"
            width="19.12"
            height="39.13"
            transform="translate(8.38 243.07) rotate(-18.42)"
          />
          <rect
            id="p25"
            class="st8"
            x="735.27"
            y="159.01"
            width="17.49"
            height="35.79"
            transform="translate(-17.78 244.16) rotate(-18.42)"
          />
          <rect
            id="p24"
            class="st8"
            x="751.87"
            y="153.5"
            width="17.49"
            height="35.79"
            transform="translate(-15.19 249.12) rotate(-18.42)"
          />
          <rect
            id="p23"
            class="st8"
            x="768.44"
            y="147.95"
            width="17.49"
            height="35.79"
            transform="translate(-12.59 254.07) rotate(-18.42)"
          />
          <rect
            id="p22"
            class="st8"
            x="746.81"
            y="192.95"
            width="17.49"
            height="37.11"
            transform="translate(-28.12 249.58) rotate(-18.42)"
          />
          <rect
            id="p21"
            class="st8"
            x="763.39"
            y="187.4"
            width="17.49"
            height="37.11"
            transform="translate(-25.52 254.53) rotate(-18.42)"
          />
          <rect
            id="p20"
            class="st8"
            x="779.99"
            y="181.89"
            width="17.49"
            height="37.11"
            transform="translate(-22.93 259.49) rotate(-18.42)"
          />
          <rect
            id="p12"
            class="st8"
            x="758.05"
            y="228.23"
            width="17.49"
            height="34.03"
            transform="translate(-38.21 254.86) rotate(-18.42)"
          />
          <rect
            id="p11"
            class="st8"
            x="774.63"
            y="222.71"
            width="17.49"
            height="34.03"
            transform="translate(-35.61 259.81) rotate(-18.42)"
          />
          <rect
            id="p10"
            class="st8"
            x="791.22"
            y="217.18"
            width="17.49"
            height="34.03"
            transform="translate(-33.02 264.77) rotate(-18.42)"
          />
          <rect
            id="p7"
            class="st8"
            x="781.36"
            y="295.3"
            width="17.57"
            height="37.13"
            transform="translate(-58.69 265.75) rotate(-18.42)"
          />
          <rect
            id="p6"
            class="st8"
            x="798.02"
            y="289.75"
            width="17.57"
            height="37.13"
            transform="translate(-56.09 270.73) rotate(-18.42)"
          />
          <rect
            id="p5"
            class="st8"
            x="814.68"
            y="284.2"
            width="17.57"
            height="37.13"
            transform="translate(-53.48 275.71) rotate(-18.42)"
          />
          <rect
            id="p3"
            class="st8"
            x="792.63"
            y="330.61"
            width="17.57"
            height="34.2"
            transform="translate(-68.81 271.05) rotate(-18.42)"
          />
          <rect
            id="p2"
            class="st8"
            x="809.29"
            y="325.06"
            width="17.57"
            height="34.2"
            transform="translate(-66.2 276.03) rotate(-18.42)"
          />
          <rect
            id="p1"
            class="st8"
            x="825.97"
            y="319.51"
            width="17.57"
            height="34.2"
            transform="translate(-63.59 281.01) rotate(-18.42)"
          />
          <rect
            id="p16"
            class="st8"
            x="685.11"
            y="250.3"
            width="17.18"
            height="36.36"
            transform="translate(-49.29 232.95) rotate(-18.42)"
          />
          <rect
            id="p15"
            class="st8"
            x="701.4"
            y="244.88"
            width="17.18"
            height="36.36"
            transform="translate(-46.75 237.82) rotate(-18.42)"
          />
          <rect
            id="p18"
            class="st8"
            x="648.91"
            y="262.51"
            width="17.72"
            height="36.21"
            transform="translate(-54.97 222.22) rotate(-18.42)"
          />
          <rect
            id="p17"
            class="st8"
            x="665.71"
            y="256.91"
            width="17.72"
            height="36.21"
            transform="translate(-52.34 227.24) rotate(-18.42)"
          />
          <rect
            id="p19"
            class="st8"
            x="649.66"
            y="223.3"
            width="22.44"
            height="36.21"
            transform="translate(-42.42 221.19) rotate(-18.42)"
          />
          <polygon
            id="p232"
            class="st8"
            points="645.24 192.22 652.22 189.89 657.98 199.94 662.68 203.54 659.39 211.4 641.91 219.15 645.24 192.22"
          />
          <rect
            id="p26"
            class="st8"
            x="668.9"
            y="175.61"
            width="40.86"
            height="22.46"
            transform="translate(-23.72 227.39) rotate(-18.42)"
          />
          <rect
            id="p14"
            class="st8"
            x="717.7"
            y="239.44"
            width="17.18"
            height="36.36"
            transform="translate(-44.19 242.69) rotate(-18.42)"
          />
          <rect
            id="p13"
            class="st8"
            x="736.25"
            y="232.77"
            width="20.1"
            height="36.36"
            transform="translate(-41.06 248.67) rotate(-18.42)"
          />
          <rect
            id="p209"
            class="st8"
            x="8.25"
            y="117.19"
            width="37.04"
            height="20.84"
          />
          <rect
            id="p210"
            class="st8"
            x="8.25"
            y="140.32"
            width="37.04"
            height="17.24"
          />
          <rect
            id="p211"
            class="st8"
            x="8.25"
            y="157.56"
            width="37.04"
            height="17.24"
          />
          <rect
            id="p212"
            class="st8"
            x="8.25"
            y="174.8"
            width="37.04"
            height="17.24"
          />
          <rect
            id="p213"
            class="st8"
            x="8.25"
            y="194.33"
            width="37.04"
            height="17.22"
          />
          <rect
            id="p214"
            class="st8"
            x="8.25"
            y="211.55"
            width="37.04"
            height="17.22"
          />
          <rect
            id="p215"
            class="st8"
            x="8.25"
            y="228.77"
            width="37.04"
            height="17.22"
          />
          <rect
            id="p216"
            class="st8"
            x="8.25"
            y="248.28"
            width="37.04"
            height="17.49"
          />
          <rect
            id="p217"
            class="st8"
            x="8.25"
            y="265.76"
            width="37.04"
            height="17.49"
          />
          <rect
            id="p218"
            class="st8"
            x="8.25"
            y="283.25"
            width="37.04"
            height="17.49"
          />
          <rect
            id="p221"
            class="st8"
            x="8.25"
            y="337.48"
            width="37.04"
            height="17.23"
          />
          <rect
            id="p220"
            class="st8"
            x="8.25"
            y="320.26"
            width="37.04"
            height="17.23"
          />
          <rect
            id="p219"
            class="st8"
            x="8.25"
            y="303.03"
            width="37.04"
            height="17.23"
          />
          <rect
            id="p226"
            class="st8"
            x="8.25"
            y="434.39"
            width="37.04"
            height="17.49"
          />
          <rect
            id="p225"
            class="st8"
            x="8.25"
            y="416.9"
            width="37.04"
            height="17.49"
          />
          <rect
            id="p224"
            class="st8"
            x="8.25"
            y="399.42"
            width="37.04"
            height="17.49"
          />
          <rect
            id="p222"
            class="st8"
            x="8.25"
            y="357"
            width="37.04"
            height="20.06"
          />
          <rect
            id="p223"
            class="st8"
            x="8.25"
            y="377.06"
            width="37.04"
            height="20.06"
          />
          <rect
            id="p227"
            class="st8"
            x="8.25"
            y="454.16"
            width="37.04"
            height="18.13"
          />
          <rect
            id="p228"
            class="st8"
            x="8.25"
            y="472.29"
            width="37.04"
            height="18.13"
          />
          <rect
            id="p229"
            class="st8"
            x="8.25"
            y="492.71"
            width="37.04"
            height="19.17"
          />
          <rect
            id="p230"
            class="st8"
            x="8.25"
            y="511.89"
            width="37.04"
            height="19.17"
          />
          <rect
            id="p190"
            class="st8"
            x="84.61"
            y="140.32"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p191"
            class="st8"
            x="84.61"
            y="157.56"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p192"
            class="st8"
            x="84.61"
            y="174.8"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p193"
            class="st8"
            x="84.61"
            y="194.33"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p194"
            class="st8"
            x="84.61"
            y="211.55"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p195"
            class="st8"
            x="84.61"
            y="228.77"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p196"
            class="st8"
            x="84.61"
            y="248.28"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p197"
            class="st8"
            x="84.61"
            y="265.76"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p198"
            class="st8"
            x="84.61"
            y="283.25"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p201"
            class="st8"
            x="84.61"
            y="337.48"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p200"
            class="st8"
            x="84.61"
            y="320.26"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p199"
            class="st8"
            x="84.61"
            y="303.03"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p164"
            class="st8"
            x="196.76"
            y="140.32"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p165"
            class="st8"
            x="196.76"
            y="157.56"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p162"
            class="st8"
            x="196.76"
            y="101.23"
            width="36.22"
            height="18.4"
          />
          <rect
            id="p163"
            class="st8"
            x="196.76"
            y="119.63"
            width="36.22"
            height="18.4"
          />
          <rect
            id="p166"
            class="st8"
            x="196.76"
            y="174.8"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p167"
            class="st8"
            x="196.76"
            y="194.33"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p168"
            class="st8"
            x="196.76"
            y="211.55"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p169"
            class="st8"
            x="196.76"
            y="228.77"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p170"
            class="st8"
            x="196.76"
            y="248.28"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p171"
            class="st8"
            x="196.76"
            y="265.76"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p172"
            class="st8"
            x="196.76"
            y="283.25"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p175"
            class="st8"
            x="196.76"
            y="337.48"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p174"
            class="st8"
            x="196.76"
            y="320.26"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p179"
            class="st8"
            x="197.88"
            y="455.72"
            width="36.74"
            height="17.76"
          />
          <rect
            id="p178"
            class="st8"
            x="197.88"
            y="437.95"
            width="36.74"
            height="17.76"
          />
          <rect
            id="p177"
            class="st8"
            x="197.88"
            y="399.42"
            width="17.81"
            height="35.89"
          />
          <rect
            id="p176"
            class="st8"
            x="215.69"
            y="399.42"
            width="17.81"
            height="35.89"
          />
          <rect
            id="p173"
            class="st8"
            x="196.76"
            y="303.03"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p143"
            class="st8"
            x="234.88"
            y="140.32"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p144"
            class="st8"
            x="234.88"
            y="157.56"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p141"
            class="st8"
            x="234.88"
            y="101.23"
            width="36.22"
            height="18.4"
          />
          <rect
            id="p142"
            class="st8"
            x="234.88"
            y="119.63"
            width="36.22"
            height="18.4"
          />
          <rect
            id="p145"
            class="st8"
            x="234.88"
            y="174.8"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p146"
            class="st8"
            x="234.88"
            y="194.33"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p147"
            class="st8"
            x="234.88"
            y="211.55"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p148"
            class="st8"
            x="234.88"
            y="228.77"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p149"
            class="st8"
            x="234.88"
            y="248.28"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p150"
            class="st8"
            x="234.88"
            y="265.76"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p151"
            class="st8"
            x="234.88"
            y="283.25"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p154"
            class="st8"
            x="234.88"
            y="337.48"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p153"
            class="st8"
            x="234.88"
            y="320.26"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p152"
            class="st8"
            x="234.88"
            y="303.03"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p158"
            class="st8"
            x="234.61"
            y="455.72"
            width="36.74"
            height="17.76"
          />
          <rect
            id="p157"
            class="st8"
            x="234.61"
            y="437.95"
            width="36.74"
            height="17.76"
          />
          <rect
            id="p160"
            class="st8"
            x="234.61"
            y="493.67"
            width="36.74"
            height="17.9"
          />
          <rect
            id="p161"
            class="st8"
            x="234.61"
            y="511.58"
            width="36.74"
            height="17.9"
          />
          <rect
            id="p159"
            class="st8"
            x="234.61"
            y="475.77"
            width="36.74"
            height="17.9"
          />
          <rect
            id="p156"
            class="st8"
            x="234.61"
            y="417.36"
            width="36.74"
            height="17.94"
          />
          <rect
            id="p155"
            class="st8"
            x="234.61"
            y="399.42"
            width="36.74"
            height="17.94"
          />
          <rect
            id="p122"
            class="st8"
            x="308.83"
            y="140.32"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p123"
            class="st8"
            x="308.83"
            y="157.56"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p120"
            class="st8"
            x="308.83"
            y="101.23"
            width="36.22"
            height="18.4"
          />
          <rect
            id="p121"
            class="st8"
            x="308.83"
            y="119.63"
            width="36.22"
            height="18.4"
          />
          <rect
            id="p124"
            class="st8"
            x="308.83"
            y="174.8"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p125"
            class="st8"
            x="308.83"
            y="194.33"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p126"
            class="st8"
            x="308.83"
            y="211.55"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p127"
            class="st8"
            x="308.83"
            y="228.77"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p128"
            class="st8"
            x="308.83"
            y="248.28"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p129"
            class="st8"
            x="308.83"
            y="265.76"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p130"
            class="st8"
            x="308.83"
            y="283.25"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p133"
            class="st8"
            x="308.83"
            y="337.48"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p132"
            class="st8"
            x="308.83"
            y="320.26"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p131"
            class="st8"
            x="308.83"
            y="303.03"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p137"
            class="st8"
            x="308.56"
            y="455.72"
            width="36.74"
            height="17.76"
          />
          <rect
            id="p136"
            class="st8"
            x="308.56"
            y="437.95"
            width="36.74"
            height="17.76"
          />
          <rect
            id="p139"
            class="st8"
            x="308.56"
            y="493.67"
            width="36.74"
            height="17.9"
          />
          <rect
            id="p140"
            class="st8"
            x="308.56"
            y="511.58"
            width="36.74"
            height="17.9"
          />
          <rect
            id="p138"
            class="st8"
            x="308.56"
            y="475.77"
            width="36.74"
            height="17.9"
          />
          <rect
            id="p135"
            class="st8"
            x="308.56"
            y="417.36"
            width="36.74"
            height="17.94"
          />
          <rect
            id="p134"
            class="st8"
            x="308.56"
            y="399.42"
            width="36.74"
            height="17.94"
          />
          <rect
            id="p119"
            class="st8"
            x="294.27"
            y="61.34"
            width="21.72"
            height="34.68"
          />
          <rect
            id="p118"
            class="st8"
            x="272.56"
            y="61.35"
            width="21.72"
            height="34.68"
          />
          <rect
            id="p99"
            class="st8"
            x="347.06"
            y="140.32"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p100"
            class="st8"
            x="347.06"
            y="157.56"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p97"
            class="st8"
            x="347.06"
            y="101.23"
            width="36.22"
            height="18.4"
          />
          <rect
            id="p98"
            class="st8"
            x="347.06"
            y="119.63"
            width="36.22"
            height="18.4"
          />
          <rect
            id="p101"
            class="st8"
            x="347.06"
            y="174.8"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p102"
            class="st8"
            x="347.06"
            y="194.33"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p103"
            class="st8"
            x="347.06"
            y="211.55"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p104"
            class="st8"
            x="347.06"
            y="228.77"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p105"
            class="st8"
            x="347.06"
            y="248.28"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p106"
            class="st8"
            x="347.06"
            y="265.76"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p107"
            class="st8"
            x="347.06"
            y="283.25"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p110"
            class="st8"
            x="347.06"
            y="337.48"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p109"
            class="st8"
            x="347.06"
            y="320.26"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p108"
            class="st8"
            x="347.06"
            y="303.03"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p114"
            class="st8"
            x="346.79"
            y="455.72"
            width="36.74"
            height="17.76"
          />
          <rect
            id="p113"
            class="st8"
            x="346.79"
            y="437.95"
            width="36.74"
            height="17.76"
          />
          <rect
            id="p116"
            class="st8"
            x="346.79"
            y="493.67"
            width="36.74"
            height="17.9"
          />
          <rect
            id="p117"
            class="st8"
            x="346.79"
            y="511.58"
            width="36.74"
            height="17.9"
          />
          <rect
            id="p115"
            class="st8"
            x="346.79"
            y="475.77"
            width="36.74"
            height="17.9"
          />
          <rect
            id="p112"
            class="st8"
            x="346.79"
            y="417.36"
            width="36.74"
            height="17.94"
          />
          <rect
            id="p111"
            class="st8"
            x="346.79"
            y="399.42"
            width="36.74"
            height="17.94"
          />
          <rect
            id="p78"
            class="st8"
            x="422.52"
            y="140.32"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p79"
            class="st8"
            x="422.52"
            y="157.56"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p77"
            class="st8"
            x="422.52"
            y="102.11"
            width="20.72"
            height="35.92"
          />
          <rect
            id="p80"
            class="st8"
            x="422.52"
            y="174.8"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p81"
            class="st8"
            x="422.52"
            y="194.33"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p82"
            class="st8"
            x="422.52"
            y="211.55"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p83"
            class="st8"
            x="422.52"
            y="228.77"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p84"
            class="st8"
            x="422.52"
            y="248.28"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p85"
            class="st8"
            x="422.52"
            y="265.76"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p86"
            class="st8"
            x="422.52"
            y="283.25"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p89"
            class="st8"
            x="422.52"
            y="337.48"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p88"
            class="st8"
            x="422.52"
            y="320.26"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p87"
            class="st8"
            x="422.52"
            y="303.03"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p93"
            class="st8"
            x="422.25"
            y="455.72"
            width="36.74"
            height="17.76"
          />
          <rect
            id="p92"
            class="st8"
            x="422.25"
            y="437.95"
            width="36.74"
            height="17.76"
          />
          <rect
            id="p95"
            class="st8"
            x="422.25"
            y="493.67"
            width="36.74"
            height="17.9"
          />
          <rect
            id="p96"
            class="st8"
            x="422.25"
            y="511.58"
            width="36.74"
            height="17.9"
          />
          <rect
            id="p94"
            class="st8"
            x="422.25"
            y="475.77"
            width="36.74"
            height="17.9"
          />
          <rect
            id="p91"
            class="st8"
            x="422.25"
            y="417.36"
            width="36.74"
            height="17.94"
          />
          <rect
            id="p90"
            class="st8"
            x="422.25"
            y="399.42"
            width="36.74"
            height="17.94"
          />
          <rect
            id="p65"
            class="st8"
            x="460.08"
            y="140.32"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p66"
            class="st8"
            x="460.08"
            y="157.56"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p67"
            class="st8"
            x="460.08"
            y="174.8"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p68"
            class="st8"
            x="460.08"
            y="194.33"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p69"
            class="st8"
            x="460.08"
            y="211.55"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p70"
            class="st8"
            x="460.08"
            y="228.77"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p71"
            class="st8"
            x="460.08"
            y="248.28"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p72"
            class="st8"
            x="460.08"
            y="265.76"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p73"
            class="st8"
            x="460.08"
            y="283.25"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p76"
            class="st8"
            x="460.08"
            y="337.48"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p75"
            class="st8"
            x="460.08"
            y="320.26"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p74"
            class="st8"
            x="460.08"
            y="303.03"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p62"
            class="st8"
            x="535.03"
            y="140.32"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p61"
            class="st8"
            x="535.03"
            y="157.56"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p64"
            class="st8"
            x="535.03"
            y="101.87"
            width="36.22"
            height="18.08"
          />
          <rect
            id="p63"
            class="st8"
            x="535.03"
            y="119.95"
            width="36.22"
            height="18.08"
          />
          <rect
            id="p60"
            class="st8"
            x="535.03"
            y="174.8"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p59"
            class="st8"
            x="535.03"
            y="194.33"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p58"
            class="st8"
            x="535.03"
            y="211.55"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p57"
            class="st8"
            x="535.03"
            y="228.77"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p56"
            class="st8"
            x="535.03"
            y="248.28"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p55"
            class="st8"
            x="535.03"
            y="265.76"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p54"
            class="st8"
            x="535.03"
            y="283.25"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p51"
            class="st8"
            x="535.03"
            y="337.48"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p50"
            class="st8"
            x="491.87"
            y="396.12"
            width="47.66"
            height="19.1"
          />
          <rect
            id="p49"
            class="st8"
            x="550.3"
            y="396.12"
            width="39.32"
            height="19.1"
          />
          <rect
            id="p52"
            class="st8"
            x="535.03"
            y="320.26"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p53"
            class="st8"
            x="535.03"
            y="303.03"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p37"
            class="st8"
            x="572.77"
            y="140.32"
            width="36.22"
            height="17.24"
          />
          <polygon
            id="p233"
            class="st8"
            points="610.59 168.12 618.18 168.12 629.64 168.12 629.64 160.74 623.88 160.74 618.18 145.98 610.59 145.98 610.59 168.12"
          />
          <rect
            id="p38"
            class="st8"
            x="572.77"
            y="157.56"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p35"
            class="st8"
            x="572.77"
            y="101.87"
            width="36.22"
            height="18.08"
          />
          <rect
            id="p36"
            class="st8"
            x="572.77"
            y="119.95"
            width="36.22"
            height="18.08"
          />
          <rect
            id="p39"
            class="st8"
            x="572.77"
            y="174.8"
            width="36.22"
            height="17.24"
          />
          <rect
            id="p40"
            class="st8"
            x="572.77"
            y="194.33"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p41"
            class="st8"
            x="572.77"
            y="211.55"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p42"
            class="st8"
            x="572.77"
            y="228.77"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p43"
            class="st8"
            x="572.77"
            y="248.28"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p44"
            class="st8"
            x="572.77"
            y="265.76"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p45"
            class="st8"
            x="572.77"
            y="283.25"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p48"
            class="st8"
            x="572.77"
            y="337.48"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p47"
            class="st8"
            x="572.77"
            y="320.26"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p46"
            class="st8"
            x="572.77"
            y="303.03"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p204"
            class="st8"
            x="84.61"
            y="434.39"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p203"
            class="st8"
            x="84.61"
            y="416.9"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p202"
            class="st8"
            x="84.61"
            y="399.42"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p189"
            class="st8"
            x="120.82"
            y="397.38"
            width="18.64"
            height="35.3"
          />
          <rect
            id="p205"
            class="st8"
            x="84.61"
            y="454.16"
            width="36.22"
            height="18.13"
          />
          <rect
            id="p206"
            class="st8"
            x="84.61"
            y="472.29"
            width="36.22"
            height="18.13"
          />
          <rect
            id="p207"
            class="st8"
            x="84.61"
            y="492.71"
            width="36.22"
            height="19.17"
          />
          <rect
            id="p208"
            class="st8"
            x="84.61"
            y="511.89"
            width="36.22"
            height="19.17"
          />
          <rect
            id="p180"
            class="st8"
            x="122.44"
            y="194.33"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p181"
            class="st8"
            x="122.44"
            y="211.55"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p182"
            class="st8"
            x="122.44"
            y="228.77"
            width="36.22"
            height="17.22"
          />
          <rect
            id="p183"
            class="st8"
            x="122.44"
            y="248.28"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p184"
            class="st8"
            x="122.44"
            y="265.76"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p185"
            class="st8"
            x="122.44"
            y="283.25"
            width="36.22"
            height="17.49"
          />
          <rect
            id="p188"
            class="st8"
            x="122.44"
            y="337.48"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p187"
            class="st8"
            x="122.44"
            y="320.26"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p186"
            class="st8"
            x="122.44"
            y="303.03"
            width="36.22"
            height="17.23"
          />
          <rect
            id="p8"
            class="st8"
            x="759.59"
            y="302.55"
            width="20.7"
            height="37.13"
            transform="translate(-62.02 259.74) rotate(-18.42)"
          />
          <rect
            id="p9"
            class="st8"
            x="714.83"
            y="313.79"
            width="40"
            height="19.57"
            transform="translate(-64.59 248.77) rotate(-18.42)"
          />
          <polygon
            id="p231"
            class="st8"
            points="679.98 339.7 700.3 339.22 697.86 325.62 672.59 324.44 679.98 339.7"
          />
          <rect
            id="p4"
            class="st8"
            x="770.86"
            y="337.87"
            width="20.7"
            height="34.2"
            transform="translate(-72.14 265.03) rotate(-18.42)"
          />
          <g id="border">
            <polygon
              class="st3"
              points="8.25 531.06 8.25 81.58 595.49 8.68 610.15 51.85 672.69 31.08 674.73 37.2 739.71 15.48 855.75 361.58 845.81 400.02 611.67 400.02 611.67 531.06 8.25 531.06"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import ParkingTableRow from "@/components/ParkingTableRow"

const slotsPerPage = 20

export default {
  name: "Parking",
  data() {
    return {
      viewType: "list",
      slots: [],
      slotsToShow: slotsPerPage,
      sortingField: "",
      sortingDirection: "max-min",
    }
  },
  created() {
    this.slots = this.$store.getters.getParkingSlots
  },
  computed: {
    filteredSlots() {
      let slotsFiltered = this._.orderBy(
        this.slots,
        this.sortingField,
        this.sortingDirection == "min-max" ? "asc" : "desc"
      ).slice(0, this.slotsToShow)
      return slotsFiltered
    },
    filteredSlotsQty() {
      return this.filteredSlots.length
    },
    soldSlots() {
      let slots = []
      for (let i = 1; i <= 230; i++) {
        if (
          this.slots.find((item) => {
            return item.title === i.toString()
          }) == undefined
        )
          slots.push(i)
      }
      return slots
    },
  },
  mounted() {
    window.scrollTo(0, 0)

    this.soldSlots.forEach((num) => {
      let el = document.getElementById("p" + num.toString())
      el.classList.add("--blocked")
    })
  },
  methods: {
    changeSorting(fieldName) {
      this.sortingField = fieldName
      this.sortingDirection =
        this.sortingDirection == "min-max" ? "max-min" : "min-max"
    },
    moreSlots() {
      this.slotsToShow += slotsPerPage
      if (this.slotsToShow > this.slots.length)
        this.slotsToShow = this.slots.length
    },
    scrollToThePlan() {
      const targetElement = document.getElementById("parking-scheme")
      targetElement.scrollIntoView()
    },
  },
  components: {
    ParkingTableRow,
  },
}
</script>

<style lang="css">
.st0 {
  fill: #404040;
}

.st1 {
  fill: #99928a;
}

.st2 {
  isolation: isolate;
}

.st3 {
  stroke-width: 1.5px;
}

.st3,
.st4,
.st5 {
  stroke-miterlimit: 10;
}

.st3,
.st6,
.st5 {
  fill: none;
  stroke: #99928a;
}

.st7,
.st8 {
  fill: #d0cac3;
}

.st8 {
  fill-opacity: 0;
}

.st9 {
  stroke-width: 0.5px;
}

.st9,
.st4 {
  fill: #ede6dc;
  stroke: #d0cac3;
}

.st9,
.st6 {
  stroke-miterlimit: 10;
}

.st4 {
  stroke-width: 0.5px;
}

.st10 {
  fill: #b0a89e;
}

.st6 {
  stroke-width: 0.35px;
}

.st5 {
  stroke-width: 0.35px;
}

.--blocked {
  fill-opacity: 0.7;
}
</style>
